import React, { useState, useRef, useEffect } from "react";
import ReactTooltip from "react-tooltip";
import { Link } from "react-router-dom";
import Navbar from "./Nav.jsx";
import Banner from "./Banner";
import { overHeadConsumables } from "atoms/General/index.js";
import { useRecoilState } from "recoil";
import { useApolloClient } from "@apollo/react-hooks";
import { ToastContainer, toast } from "react-toastify";
import Spinner from "../../Spinner.svg";
import socketIOClient from "socket.io-client";
import constant from "../../utils/constants";
import { RESPONSE_MESSAGES, FIELD_NAMES } from "../../utils/constantenums.js";
import gql from "graphql-tag";
import { useMutation } from "@apollo/react-hooks";
import BatchFillingPop from "./BatchFillingPopUp";
import { useAccess } from "state/hooks.js";
import { CONDITIONALROUTES } from "./ConditionalEnums/index.js";
import { hideFieldForHetrogenousJobs } from "utils/validations";
import { areRequiredFieldsFilled, isRequiredField } from "utils/function.js";
import OverrideAbleTip from "./ProductionScenario/OverrideAbleTip.jsx";

const SAVE_CLIENT_CALCULATIONS = gql`
  mutation saveClientCalculations($calculations: Object) {
    saveClientCalculations(calculations: $calculations)
  }
`;

const RESET_CUSTOMIZED_FIELD = gql`
  mutation resetCustomizedValue($field_id: Int!) {
    resetCustomizedValue(field_id: $field_id)
  }
`;

const SAVE_CUSTOMIZED_FIELD = gql`
  mutation createClientCustomizedField(
    $machine_id: Int!
    $region_id: Int!
    $technology_id: Int!
    $field_id: Int!
    $calculator_type: String!
    $value: Float!
    $param_id: Int
    $material_id: Int
  ) {
    createClientCustomizedField(
      machine_id: $machine_id
      region_id: $region_id
      technology_id: $technology_id
      field_id: $field_id
      calculator_type: $calculator_type
      value: $value
      param_id: $param_id
      material_id: $material_id
    ) {
      machine_id
      region_id
      technology_id
      field_id
      calculator_type
      value
      material_id
      param_id
    }
  }
`;

const CalculatorHeader = () => {
  let technology_name = sessionStorage.getItem("technology");
  let step_type_id = +sessionStorage.getItem("stepTypeId");
  let Access = useAccess();
  const [fieldDataAvailability, setFieldDataAvailability] = useState(false);
  // const calculatorType = useRecoilValue(CalculatorType)
  // console.log("calculatorType: ", calculatorType)

  const calculatorType = sessionStorage.getItem("calculatorType");

  const client = useApolloClient();
  let [techSteps, setTechSteps] = useState([]);
  let [stepName, setStepName] = useState([]);
  let [technologyName, setTechnologyName] = useState([]);
  let [tempHetrogeneousJobs, setTempHetrogeneousJobs] = useState([]);
  let [formFields, setFormFields] = useState([]);
  const formFieldsRef = useRef(formFields);
  let [textColor, setTextColor] = useState("#B4B4BD");

  const [, setOverHeadConsumables] = useRecoilState(overHeadConsumables);
  let checkArray1 = [];
  let checkArray2 = [];
  let checkArray3 = [];

  let [machine_options, setMachineOptions] = useState([]);
  let [material_options, setMaterialtOptions] = useState([]);
  let [parameters_options, setParametersOptions] = useState([]);
  let [fill_rate_options, setFillRateOptions] = useState([]);
  let [filter_options, setFilterOptions] = useState([]);
  let [recoater_blade_options, setRecoaterBladeOptions] = useState([]);
  let [inert_gas_options, setInertGasOptions] = useState([]);
  let [build_platform_options, setBuildPlatformOptions] = useState([]);

  let [stepFields, setStepFields] = useState([]);
  let [socketObj, setSocketObj] = useState({});
  let [stepId, setStepId] = useState(-1);
  let [technologyId, setTechnologyId] = useState(-1);
  let [socketArray, setSocketArray] = useState([]);
  sessionStorage.setItem("reportStatus", "unsave");

  let [fieldsLoader, setFieldsLoader] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [checkSocketEmit, setSocketEmit] = useState(false);
  const [checkSocketEmitMetal, setSocketEmitMetal] = useState(false);
  // Form Fields of calculators for full simulation of verticle 1 and 2...
  // console.log("formFields check", formFields);
  const [subFieldsByFieldId, setSubFieldsByFieldId] = useState([]);
  const [toggleMutation] = useMutation(SAVE_CLIENT_CALCULATIONS);
  const [mutateFunction, { loading: savingCustomizedFieldLoading }] =
    useMutation(SAVE_CUSTOMIZED_FIELD);
  const [mutateResetCustomizedField, { loading: resettingFieldLoading }] =
    useMutation(RESET_CUSTOMIZED_FIELD);

  useEffect(() => {
    formFieldsRef.current = formFields;
  }, [formFields]);

  // Field IDs that require 86% width when field_unit is present
  const FIELD_IDS_WITH_SPECIAL_WIDTH = [114, 17, 74, 75, 76, 197, 198, 199];

  const getStepId = () => {
    if (technology_name === "Polymer") {
      return 2;
    } else {
      return 1;
    }
  };

  React.useEffect(() => {
    setRegionId();
    window.localStorage.setItem("CPP OC", 0);
    setOverHeadConsumables(0);
    const socket = socketIOClient(constant.uri);
    console.log("URL", constant.uri);
    const patch = require("socketio-wildcard")(socketIOClient.Manager);
    patch(socket);
    setSocketObj(socket);
    var technology_id = getStepId();
    setTechnologyId(technology_id);
    let array = formFields;
    array["technology_id"] = { value: parseInt(technologyId), override: false };
    array["step_type_id"] = { value: parseInt(step_type_id), override: false };
    array["stacking"] = { value: 1, override: false };
    array["adjustment_factor"] = { value: 1, override: false };
    setFormFields({ ...formFields, ...array });
    client
      .query({
        query: constant.GET_STEPS,
        variables: { technology_id, type_id: step_type_id },
      })
      .then((res) => {
        const clientSteps = res.data?.getClientSteps;
        if (
          !clientSteps ||
          !Array.isArray(clientSteps) ||
          clientSteps.length === 0
        ) {
          console.error("No client steps found");
          return;
        }
        setTechSteps(clientSteps);
        setLoading(true);
        setStepName(`${clientSteps[0].name}`);
        setStepId(clientSteps[0].step_id);
        setTechnologyName(
          `${clientSteps[0].technology_id.name} ${clientSteps[0].step_type_id.name}`,
        );
        client
          .query({
            query: constant.GET_STEPS_FIELDS,
            variables: { step_id: clientSteps[0].step_id },
          })
          .then((res) => {
            if (!res?.data?.getFieldsByStepId) {
              console.error("No fields found for step");
              return;
            }
            for (
              let index = 0;
              index < res.data.getFieldsByStepId.length;
              index++
            ) {
              res.data.getFieldsByStepId[index].loader = false;
            }
            let array = res.data.getFieldsByStepId;
            setStepFields(array);
            checkOptionalFields(array);
            // Create a copy of clientSteps to avoid stale state issues
            let techStepsArr = clientSteps.map((step) => ({ ...step }));
            // Tech steps used in full simulation for metal and polymer...
            // console.log("Tech Steps", techStepsArr);
            techStepsArr[0].fields = array;

            sessionStorage.setItem(
              "stepsAndFields",
              JSON.stringify(techStepsArr),
            );
            getFieldValues(null, false);
            setLoading(true);
            if (
              sessionStorage.getItem("stepId") &&
              sessionStorage.getItem("calculator_values_default")
            ) {
              handlestep(parseInt(sessionStorage.getItem("stepId")));
            }
          })
          .catch((error) => {
            console.log(error);
            if (
              error?.graphQLErrors &&
              Array.isArray(error.graphQLErrors) &&
              error.graphQLErrors.length > 0 &&
              error.graphQLErrors[0]?.extensions?.exception?.response
                ?.status === 401
            ) {
              toast.error(
                error.graphQLErrors[0]?.extensions?.exception?.response
                  ?.message,
              );
              window.location.href = "/";
            }
          });
      })
      .catch((error) => {
        // console.log(error);
        // if (error.graphQLErrors[0].extensions.exception.response.status === 401) {
        //     toast.error(error.graphQLErrors[0].extensions.exception.response.message)
        //     window.location.href = '/';
        // }
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [techSteps]);
  //   console.log("stepFields ", stepFields);

  // Optional Fields Part Names, Company Names, Application...

  React.useEffect(() => {
    if (
      sessionStorage.getItem("calculator_values_default") &&
      !checkSocketEmit
    ) {
      let autoFlag = false;
      for (let index = 0; index < stepFields.length; index++) {
        if (
          stepFields[index].field_input_type === "dropdown" &&
          stepFields[index].keys !== "batch_filling_grade"
        ) {
          autoFlag = false;
          break;
        }
        if (
          stepFields[index].field_input_type === "textfield" &&
          stepFields[index].keys !== "other_post_processing_cost_per_part"
        ) {
          autoFlag = false;
          break;
        }
        autoFlag = true;
      }
      let optionalFields = stepFields.filter((x) => x.is_optional === true);
      let constantFields = stepFields.filter(
        (x) => x.field_type === "constant",
      );
      let resultFields = [];
      if (optionalFields.length > 0 && constantFields.length > 0) {
        resultFields = optionalFields.concat(constantFields);
      } else if (optionalFields.length > 0) {
        resultFields = optionalFields;
      } else if (constantFields.length > 0) {
        resultFields = constantFields;
      } else {
        resultFields = []; // If both arrays are empty, resultFields will be an empty array
      }
      if (resultFields && resultFields.length) {
        const formFieldsKeys = Object.keys(formFields);
        for (let index = 0; index < resultFields.length; index++) {
          if (formFieldsKeys.includes(`${resultFields[index].keys}`)) {
            autoFlag = true;
          } else {
            autoFlag = false;
          }
        }

        if (autoFlag) {
          if (stepId !== 45) {
            getFieldValues(null, false);
          }
          setSocketEmit(true);
        }
        setFieldsLoader(false);
        setLoading(true);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formFields]);

  React.useEffect(() => {
    if (build_platform_options.length && !checkSocketEmitMetal) {
      getFieldValues(null, false);
      setSocketEmitMetal(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [build_platform_options]);

  const checkOptionalFields = (array) => {
    const formFieldsObj = formFields;
    for (let index = 0; index < array.length; index++) {
      if (array[index].is_optional) {
        // console.log("Array Index Names", array[index].name);
        if (array[index].name === "Application") {
        }
        if (array[index].field_type === "constant") {
          formFieldsObj[array[index].keys] = {
            value: array[index].data_reference,
            override: false,
          };
        } else if (array[index].field_data_type !== "string") {
          formFieldsObj[array[index].keys] = {
            value: array[index].keys === "adjustment_factor" ? 1 : 0,
            override: false,
          };
        } else {
          formFieldsObj[array[index].keys] = { value: "", override: false };
        }
      } else {
        if (array[index].field_data_type !== "string") {
          formFieldsObj[array[index].keys] = {
            value: array[index].keys === "adjustment_factor" ? 1 : 0,
            override: false,
          };
        }
      }
    }
    setFormFields({ ...formFields, ...formFieldsObj });
    // console.log("Check Form Option Fields", formFields);
  };

  const setRegionId = () => {
    const currencies = JSON.parse(sessionStorage.getItem("all_currencies"));
    // console.log("Getting Currencies from session", currencies);
    const currency = sessionStorage.getItem("currency");
    // const obj = currencies.find((x) => x.name === currency);
    const obj = currencies?.find((x) => x?.currency_symbol === currency);

    let array = formFields;
    array["region_id"] = { value: parseInt(obj.region_id), override: false };
    setFormFields({ ...formFields, ...array });
    // console.log("Set Form in Set Region Id", formFields);
  };

  const handlestep = (stepIdVar) => {
    setStepId(stepIdVar);
    setFieldsLoader(true);
    // Handling Dynamically Active States of Steps
    const divs = document.getElementsByClassName("progress-stage");
    for (let index = 0; index < divs.length; index++) {
      divs[index].classList.remove("arrow-back");
    }

    for (let index = 0; index < stepFields.length; index++) {
      if (
        document.getElementById(`edit-${stepFields[index].field_id}`) != null
      ) {
        document
          .getElementById(`edit-${stepFields[index].field_id}`)
          .classList.remove("hidden");
      }
      if (
        document.getElementById(`cross-${stepFields[index].field_id}`) != null
      ) {
        document
          .getElementById(`cross-${stepFields[index].field_id}`)
          .classList.add("hidden");
      }
      if (
        document.getElementById(`div-${stepFields[index].field_id}`) != null
      ) {
        document
          .getElementById(`div-${stepFields[index].field_id}`)
          .classList.add("hidden");
      }
      if (
        document.getElementById(`input-${stepFields[index].field_id}`) != null
      ) {
        document.getElementById(`input-${stepFields[index].field_id}`).value =
          0;
      }
    }

    document.getElementById(stepIdVar).classList.add("arrow-back");
    const flags = document.getElementsByClassName(`flag-class`);
    for (let index = 0; index < flags.length; index++) {
      flags[index].classList.remove("flag-next");
    }
    document.getElementById(`flag-${stepIdVar}`).classList.add("flag-next");
    // End

    //Handling Selected and Unselected Icons
    const unSelectedTechSteps = techSteps.filter(
      (x) => x.step_id !== stepIdVar,
    );
    for (let index = 0; index < unSelectedTechSteps.length; index++) {
      document.getElementById(
        `image-${unSelectedTechSteps[index].step_id}`,
      ).src = unSelectedTechSteps[index].unselected_icon;
    }
    const selectedIcon = techSteps.find((x) => x.step_id === stepIdVar);
    if (!selectedIcon) {
      console.error(`Step with id ${stepIdVar} not found`);
      return;
    }
    document.getElementById(`image-${stepIdVar}`).src =
      selectedIcon.selected_icon;
    //End
    setStepName(`${selectedIcon.name}`);
    if (
      techSteps &&
      techSteps.length > 0 &&
      techSteps[0]?.technology_id &&
      techSteps[0]?.step_type_id
    ) {
      setTechnologyName(
        `${techSteps[0].technology_id.name} ${techSteps[0].step_type_id.name}`,
      );
    }
    // Getting Fields by Step Id
    client
      .query({
        query: constant.GET_STEPS_FIELDS,
        variables: { step_id: stepIdVar },
      })
      .then((res) => {
        setSocketArray([]);
        for (
          let index = 0;
          index < res.data.getFieldsByStepId.length;
          index++
        ) {
          res.data.getFieldsByStepId[index].loader = false;
        }
        // TODO Logic commented out as per client requirement for now this logic is used when hetrogenous(multiple parts) are added wo have to show multiple CPP parts this is adding cpp parts based on addition for hetrogenous parts
        // if (tempHetrogeneousJobs.length > 0) {
        // const indexCpp = res.data.getFieldsByStepId.findIndex(
        //   (x) =>
        //     x.field_input_type === "multiple_labels" && x.keys === "cpp_part"
        // );
        // if (indexCpp !== -1) {
        //   const length =
        //     technologyId === 1
        //       ? tempHetrogeneousJobs.length / 3
        //       : tempHetrogeneousJobs.length / 2;
        //   for (let index = 0; index < length; index++) {
        //     const existMultipleLabel = res.data.getFieldsByStepId.find(
        //       (x) => x.field_input_type === "multiple_labels"
        //     );
        //     if (existMultipleLabel) {
        //       let obj = Object.assign({}, existMultipleLabel);
        //       res.data.getFieldsByStepId.splice(indexCpp + index, 0, obj);
        //     }
        //   }
        //   for (let index = 0; index < length + 1; index++) {
        //     res.data.getFieldsByStepId[indexCpp + index].name = `CPP Part ${index + 1
        //       }`;
        //     res.data.getFieldsByStepId[indexCpp + index].keys = `cpp_part_${index + 1
        //       }`;
        //   }
        // }
        // }
        stepFields = res.data.getFieldsByStepId;
        setStepFields(stepFields);
        const recurring_expense = stepFields?.filter(
          (x) =>
            x.keys === FIELD_NAMES?.RECURRING_EXPENSE ||
            x.keys === FIELD_NAMES?.SERVICE_EXPENSE,
        );
        if (!!recurring_expense && !!recurring_expense.length) {
          getSubFieldsById(recurring_expense?.[0].field_id);
        }
        const stepsAndFields = JSON.parse(
          sessionStorage.getItem("stepsAndFields"),
        );
        const findIndexVar = stepsAndFields.findIndex(
          (x) => x.step_id === stepIdVar,
        );
        if (findIndexVar !== -1) {
          stepsAndFields[findIndexVar].fields = res.data.getFieldsByStepId;
        }
        sessionStorage.setItem(
          "stepsAndFields",
          JSON.stringify(stepsAndFields),
        );

        if (!sessionStorage.getItem("calculator_values_default")) {
          let formFieldsObj = formFields;
          let optionalFields = stepFields.filter((x) => x.is_optional === true);
          for (let index = 0; index < optionalFields.length; index++) {
            if (optionalFields[index].field_type === "constant") {
              formFieldsObj[optionalFields[index].keys] = {
                value: stepFields[index].data_reference,
                override: false,
              };
            } else if (optionalFields[index].field_data_type !== "string") {
              formFieldsObj[optionalFields[index].keys] = {
                value:
                  optionalFields[index].keys === "adjustment_factor" ? 1 : 0,
                override: false,
              };
            } else {
              formFieldsObj[optionalFields[index].keys] = {
                value: "",
                override: false,
              };
            }
          }
          setFormFields({ ...formFields, ...formFieldsObj });
          let autoFlag = false;
          for (let index = 0; index < stepFields.length; index++) {
            if (
              stepFields[index].field_input_type === "dropdown" &&
              stepFields[index].keys !== "batch_filling_grade"
            ) {
              autoFlag = false;
              break;
            }
            if (
              stepFields[index].field_input_type === "textfield" &&
              stepFields[index].keys !== "other_post_processing_cost_per_part"
            ) {
              autoFlag = false;
              break;
            }
            autoFlag = true;
          }

          let constantFields = stepFields.filter(
            (x) => x.field_type === "constant",
          );
          if (constantFields.length) {
            // Constant field of full simualation...
            // console.log("Constant Fields");
            let array = formFields;
            for (let index = 0; index < constantFields.length; index++) {
              array[constantFields[index].keys] = {
                value: constantFields[index].data_reference,
                override: false,
              };
            }
            setFormFields({ ...formFields, ...array });
          }
          if (autoFlag && stepId !== 45) {
            getFieldValues(null, false);
          }
          if (
            !Object.keys(formFields).includes("calculator_type") &&
            !Object.keys(formFields).includes("user_id")
          ) {
            let formFieldsObj = formFields;
            formFieldsObj["calculator_type"] = {
              value: calculatorType,
              override: false,
            };
            formFieldsObj["user_id"] = {
              value: sessionStorage.getItem("user_id"),
              override: false,
            };
            setFormFields({ ...formFields, ...formFieldsObj });
          }
          setSocketEmitMetal(false);
          setFieldsLoader(false);
          setLoading(true);
        } else {
          let formFieldsObj = JSON.parse(
            sessionStorage.getItem("calculator_values_default"),
          );
          let optionalFields = stepFields.filter((x) => x.is_optional === true);
          let constantFields = stepFields.filter(
            (x) => x.field_type === "constant",
          );

          let resultFields = [];
          if (optionalFields.length > 0 && constantFields.length > 0) {
            resultFields = optionalFields.concat(constantFields);
          } else if (optionalFields.length > 0) {
            resultFields = optionalFields;
          } else if (constantFields.length > 0) {
            resultFields = constantFields;
          } else {
            resultFields = []; // If both arrays are empty, resultFields will be an empty array
          }
          if (resultFields && resultFields.length) {
            for (let index = 0; index < resultFields.length; index++) {
              if (resultFields[index].field_type === "constant") {
                formFieldsObj[resultFields[index].keys] = {
                  value: resultFields[index].data_reference,
                  override: false,
                };
              } else if (resultFields[index].field_data_type !== "string") {
                formFieldsObj[resultFields[index].keys] = {
                  value:
                    resultFields[index].keys === "adjustment_factor" ? 1 : 0,
                  override: false,
                };
              } else {
                formFieldsObj[resultFields[index].keys] = {
                  value: "",
                  override: false,
                };
              }
            }
            setSocketEmit(false);
            setSocketEmitMetal(false);
            setFormFields({ ...formFields, ...formFieldsObj });
          }
        }
      })
      .catch((error) => {
        // toast.error(error.graphQLErrors[0].messasge.message)
      });

    //
  };
  const unRegisterSocketEvents = () => {
    socketObj.off("*");
  };

  const emitSocket = (key) => {
    const fieldObj = stepFields.find((x) => x.formula === key);
    const currentFormFields = formFieldsRef.current;
    if (
      fieldObj &&
      key !== "FOBV-Single-Multi" &&
      fieldObj &&
      key !== "FO-Total-PV"
    ) {
      const formula_inputs_array = fieldObj.formula_inputs.split(",");
      // console.log("formula_inputs_array",formula_inputs_array,fieldObj.formula)
      let obj = {};
      for (let index = 0; index < formula_inputs_array.length; index++) {
        if (
          currentFormFields[formula_inputs_array[index].trim()] &&
          formula_inputs_array[index].trim() !== "hetrojobs" &&
          currentFormFields[formula_inputs_array[index].trim()] !== -1
        ) {
          obj[formula_inputs_array[index].trim()] =
            formula_inputs_array[index].trim() === "calculator_type"
              ? currentFormFields[formula_inputs_array[index].trim()].value
              : parseFloat(
                  currentFormFields[formula_inputs_array[index].trim()].value,
                );
        } else if (currentFormFields[formula_inputs_array[index].trim()]) {
          obj[formula_inputs_array[index].trim()] =
            currentFormFields[formula_inputs_array[index].trim()];
        } else if (formula_inputs_array[index].trim() === "is_customizable") {
          obj[formula_inputs_array[index].trim()] = fieldObj?.is_customizable;
        } else if (formula_inputs_array[index].trim() === "field_id") {
          obj[formula_inputs_array[index].trim()] = fieldObj?.field_id;
        }
        //added new check bcz of new service_expenses field rename
        if (
          formula_inputs_array.some((k) => k.trim() === "calculator_type") &&
          obj["calculator_type"] === undefined
        ) {
          obj["calculator_type"] =
            currentFormFields["calculator_type"]?.value ?? calculatorType;
        }
        if (
          formula_inputs_array.some((k) => k.trim() === "user_id") &&
          obj["user_id"] === undefined
        ) {
          obj["user_id"] =
            currentFormFields["user_id"]?.value ??
            sessionStorage.getItem("user_id");
        }
      }
      if (Object.keys(obj).length !== formula_inputs_array.length) {
        const missingInputs = formula_inputs_array.filter(
          (inp) => !Object.keys(obj).includes(inp.trim()),
        );
        console.log(
          `SKIP formula ${key}: missing inputs=`,
          missingInputs,
          "obj=",
          obj,
        );
      }
      if (Object.keys(obj).length === formula_inputs_array.length) {
        // console.log("this is 1")
        const fieldIndex = stepFields.findIndex((x) => x.formula === key);
        if (fieldIndex !== -1) {
          let array = stepFields;
          array[fieldIndex].loader = true;
          setStepFields([...array]);
        }
        if (key === 'FO-CPPOC2') {
          socketObj.emit("calculator", { key: key, input: obj, calculator_type: calculatorType });
        }
        else {
           // console.log("this function",obj,key)
          socketObj.emit("calculator", { key: key, input: obj });
        }
      } else {
        const fieldIndex = stepFields.findIndex((x) => x.formula === key);
        if (fieldIndex !== -1) {
          let array = stepFields;
          array[fieldIndex].loader = false;
          setStepFields([...array]);
        }
        const findIndex = socketArray.findIndex((x) => x.formula === key);
        if (findIndex !== -1 && findIndex + 1 !== socketArray.length) {
          const fieldIndex = stepFields.findIndex(
            (x) => x.formula === socketArray[findIndex + 1].formula,
          );
          if (fieldIndex !== -1) {
            let array = stepFields;
            array[fieldIndex].loader = true;
            setStepFields([...array]);
          }
          emitSocket(socketArray[findIndex + 1].formula);
        }
      }
    } else if (
      (fieldObj &&
        fieldObj.keys === "build_volume" &&
        formFields["step_type_id"].value === 2) ||
      (fieldObj &&
        fieldObj.keys === "total_part_volume" &&
        formFields["step_type_id"].value === 2)
    ) {
      const formula_inputs_array = fieldObj.formula_inputs.split(",");
      let array = [];
      let hetroFlag = false;

      if (formFields[constant.HETROGENEOUS]) {
        for (
          let index = 0;
          index < formFields[constant.HETROGENEOUS].length;
          index++
        ) {
          for (let jindex = 0; jindex < formula_inputs_array.length; jindex++) {
            if (
              !formFields[constant.HETROGENEOUS][index][
                formula_inputs_array[jindex].trim()
              ]
            ) {
              hetroFlag = true;
              break;
            }
          }
          if (hetroFlag) {
            break;
          } else {
            array.push(formFields[constant.HETROGENEOUS][index]);
          }
        }
        if (array.length === formFields[constant.HETROGENEOUS].length) {
          const fieldIndex = stepFields.findIndex((x) => x.formula === key);
          if (fieldIndex !== -1) {
            let array = stepFields;
            array[fieldIndex].loader = true;
            setStepFields([...array]);
          }
          socketObj.emit("calculator", { key: key, input: array });
        } else {
          const fieldIndex = stepFields.findIndex((x) => x.formula === key);
          if (fieldIndex !== -1) {
            let array = stepFields;
            array[fieldIndex].loader = false;
            setStepFields([...array]);
          }
          const findIndex = socketArray.findIndex((x) => x.formula === key);
          if (findIndex !== -1 && findIndex + 1 !== socketArray.length) {
            const fieldIndex = stepFields.findIndex(
              (x) => x.formula === socketArray[findIndex + 1].formula,
            );
            if (fieldIndex !== -1) {
              let array = stepFields;
              array[fieldIndex].loader = true;
              setStepFields([...array]);
            }
            emitSocket(socketArray[findIndex + 1].formula);
          }
        }
      }
    } else {
      console.log("Not Emitting", fieldObj);
    }
  };

  const renderSteps = () => {
    return techSteps.map((steps, index) => {
      return (
        <>
          <div
            id={steps.step_id}
            key={steps.name}
            data-tip={steps.description}
            className={
              " progress-stage deadcenter " + (index === 0 ? "arrow-back" : "")
            }
            onClick={() => {
              handlestep(steps.step_id);
            }}
          >
            <div
              className={
                "stage " +
                (steps.name === "Overhead & Consumable" ? "min-width" : "")
              }
            >
              <img
                alt=""
                className="icon-image"
                id={"image-" + steps.step_id}
                src={index === 0 ? steps.selected_icon : steps.unselected_icon}
                width="24"
                height="20"
              />
              <p className="d-flex">
                {steps.name}
                {/* {step_type_id === 1 && (steps.step_id === 48 || steps.step_id === 40) && !Access && <a href="/premium-request" className="premium-row-text py-1" >Premium</a>} */}
              </p>
            </div>
          </div>
          <div
            style={{ display: "hidden" }}
            id={"flag-" + steps.step_id}
            className={"flag-class " + (index === 0 ? "flag-next" : "")}
          ></div>
        </>
      );
    });
  };
  const getSubFieldsById = (fieldId) => {
    client
      .query({
        query: constant.GET_SUB_FIELDS_BY_ID,
        variables: { field_id: fieldId },
      })
      .then((res) => {
        let array = formFields;
        for (
          let index = 0;
          index < res?.data?.getSubFieldsByFieldId.length;
          index++
        ) {
          array[
            res?.data?.getSubFieldsByFieldId[index]?.name
              ?.toLowerCase()
              ?.replace(" ", "_")
          ] = { value: 0, override: true };
        }
        setFormFields({ ...formFields, ...array });
        setSubFieldsByFieldId(res?.data?.getSubFieldsByFieldId);
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const addMoreJobs = (technologyName, traversalIndex) => {
    // Silent guard: do not exceed 3 heterogeneous jobs or combined 3 with scenarios
    let currentHetroJobsCount = 0;
    if (technologyName === "Polymer Simulation") {
      currentHetroJobsCount = tempHetrogeneousJobs.length / 2;
    } else {
      currentHetroJobsCount = tempHetrogeneousJobs.length / 3;
    }

    let scenariosCount = 0;
    const calculatorValuesNames = sessionStorage.getItem(
      "calculator_values_names",
    );
    if (calculatorValuesNames) {
      try {
        const parsedNames = JSON.parse(calculatorValuesNames);
        if (Array.isArray(parsedNames)) {
          scenariosCount = parsedNames.filter(
            (name) => name !== constant.DEFAULT_SCENARIO,
          ).length;
        }
      } catch (error) {
        // ignore parsing issues
      }
    }

    if (
      currentHetroJobsCount >= 4 ||
      currentHetroJobsCount + scenariosCount >= 4
    ) {
      return;
    }

    const calculatedFields = [];
    if (technologyName === "Polymer Simulation") {
      const limitIndex = traversalIndex - 2;
      for (let index = limitIndex; index < traversalIndex; index++) {
        calculatedFields.push(stepFields[index]);
      }
      const array = [...tempHetrogeneousJobs, ...calculatedFields];
      setTempHetrogeneousJobs(array);
    } else {
      const limitIndex = traversalIndex - 3;
      for (let index = limitIndex; index < traversalIndex; index++) {
        calculatedFields.push(stepFields[index]);
      }
      const array = [...tempHetrogeneousJobs, ...calculatedFields];
      setTempHetrogeneousJobs(array);
    }
  };

  const openEditBox = (fieldId, flag, fieldKey = "") => {
    if (
      fieldKey === FIELD_NAMES?.RECURRING_EXPENSE ||
      fieldKey === FIELD_NAMES?.SERVICE_EXPENSE
    ) {
      const spaceOne = document.getElementById(`row-spaceOne-${fieldId}`);
      const spaceTwo = document.getElementById(`row-spaceTwo-${fieldId}`);
      const spaceThree = document.getElementById(`row-spaceThree-${fieldId}`);
      const spaceFour = document.getElementById(`row-spaceFour-${fieldId}`);
      const spaceFive = document.getElementById(`row-spaceFive-${fieldId}`);
      const spaceSix = document.getElementById(`row-spaceSix-${fieldId}`);

      if (spaceOne) spaceOne.classList.remove("hidden");
      if (spaceTwo) spaceTwo.classList.remove("hidden");
      if (spaceThree) spaceThree.classList.remove("hidden");
      if (spaceFour) spaceFour.classList.remove("hidden");
      if (spaceFive) spaceFive.classList.remove("hidden");
      if (spaceSix) spaceSix.classList.remove("hidden");
    }
    if (flag) {
      const editIcon = document.getElementById(`edit-${fieldId}`);
      const crossIcon = document.getElementById(`cross-${fieldId}`);
      const editDiv = document.getElementById(`div-${fieldId}`);
      const saveIcon = document.getElementById(`save-${fieldId}`);
      const restoreIcon = document.getElementById(`restore-${fieldId}`);
      const inputField = document.getElementById(`input-${fieldId}`);
      const inputWrapper = document.getElementById(`input-wrapper-${fieldId}`);

      if (editIcon) editIcon.classList.add("hidden");
      if (crossIcon) crossIcon.classList.remove("hidden");
      if (editDiv) editDiv.classList.remove("hidden");
      if (saveIcon) saveIcon.classList.remove("hidden");
      if (restoreIcon) restoreIcon.classList.remove("hidden");
      if (inputField) inputField.classList.remove("hidden");
    } else {
      const editIcon = document.getElementById(`edit-${fieldId}`);
      const crossIcon = document.getElementById(`cross-${fieldId}`);
      const editDiv = document.getElementById(`div-${fieldId}`);
      const saveIcon = document.getElementById(`save-${fieldId}`);
      const restoreIcon = document.getElementById(`restore-${fieldId}`);
      const inputField = document.getElementById(`input-${fieldId}`);
      const inputWrapper = document.getElementById(`input-wrapper-${fieldId}`);

      if (editIcon) editIcon.classList.remove("hidden");
      if (crossIcon) crossIcon.classList.add("hidden");
      if (editDiv) editDiv.classList.add("hidden");

      if (
        fieldKey === FIELD_NAMES?.RECURRING_EXPENSE ||
        fieldKey === FIELD_NAMES?.SERVICE_EXPENSE
      ) {
        if (inputWrapper) {
          inputWrapper.classList.remove("hidden");
        }
        const spaceOne = document.getElementById(`row-spaceOne-${fieldId}`);
        const spaceTwo = document.getElementById(`row-spaceTwo-${fieldId}`);
        const spaceThree = document.getElementById(`row-spaceThree-${fieldId}`);
        const spaceFour = document.getElementById(`row-spaceFour-${fieldId}`);
        const spaceFive = document.getElementById(`row-spaceFive-${fieldId}`);
        const spaceSix = document.getElementById(`row-spaceSix-${fieldId}`);

        if (spaceOne) spaceOne.classList.add("hidden");
        if (spaceTwo) spaceTwo.classList.add("hidden");
        if (spaceThree) spaceThree.classList.add("hidden");
        if (spaceFour) spaceFour.classList.add("hidden");
        if (spaceFive) spaceFive.classList.add("hidden");
        if (spaceSix) spaceSix.classList.add("hidden");
        // Do not reset SERVICE_EXPENSE / SOFTWARE_EXPENSE / MISCELLANEOUS values here.
        // We want user-entered subfield values to persist and be stored in sessionStorage.
      }

      if (saveIcon) saveIcon.classList.add("hidden");
      if (restoreIcon) restoreIcon.classList.add("hidden");
      // For RECURRING_EXPENSE, keep the main input visible when the edit box closes.
      // Other fields should still hide their input when closing the edit box.
      if (
        (fieldKey !== FIELD_NAMES?.RECURRING_EXPENSE ||
          fieldKey !== FIELD_NAMES?.SERVICE_EXPENSE) &&
        inputField
      ) {
        inputField.classList.add("hidden");
      }

      const fieldObj = stepFields.find((x) => x.field_id === fieldId);
      if (fieldObj) {
        if (formFields[fieldObj.keys]) {
          let array = formFields;
          array[fieldObj.keys].override = false;
          setFormFields({ ...formFields, ...array });
          getFieldValues(null, false);
        }
      }
    }
  };

  const normalizeUnit = (unit) => {
    if (!unit || typeof unit !== "string") return unit;
    return unit.replace(/³/g, "3").replace(/²/g, "2");
  };

  const renderSubscript = (unit) => {
    unit = normalizeUnit(unit);
    if (unit === "cm3") {
      return (
        <span className="subscript-span">
          <var>
            cm<sup>3</sup>
          </var>
        </span>
      );
    } else if (unit === "mm") {
      return (
        <span className="subscript-span">
          <var>mm</var>
        </span>
      );
    } else if (unit === "currency") {
      const currencies = JSON.parse(sessionStorage.getItem("all_currencies"));
      const currency = sessionStorage.getItem("currency");
      const obj = currencies.find((x) => x.currency_symbol === currency);
      if (obj) {
        return <span className="subscript-span">{obj.currency_symbol}</span>;
      } else {
        return <></>;
      }
    } else if (unit === "g/cm3") {
      return (
        <span className="subscript-span">
          <var>
            g/cm<sup>3</sup>
          </var>
        </span>
      );
    } else if (unit === "year" || unit === "years") {
      return <span className="subscript-span">year</span>;
    } else if (unit === "%") {
      return <span className="subscript-span">%</span>;
    } else if (unit === "hours" || unit === "hour") {
      return <span className="subscript-span">hours</span>;
    } else if (unit === "hours/year") {
      return <span className="subscript-span">hours/year</span>;
    } else if (unit === "μm") {
      return <span className="subscript-span">μm</span>;
    } else if (unit === "mm/h") {
      return <span className="subscript-span">mm/h</span>;
    } else if (unit === "kg") {
      return <span className="subscript-span">kg</span>;
    } else if (unit === "m2") {
      return (
        <span className="subscript-span">
          <var>
            m<sup>2</sup>
          </var>
        </span>
      );
    } else if (unit === "currency/m2") {
      const currencies = JSON.parse(sessionStorage.getItem("all_currencies"));
      const currency = sessionStorage.getItem("currency");
      const obj = currencies.find((x) => x.currency_symbol === currency);
      if (obj) {
        return (
          <span className="subscript-span">
            <var>
              {obj.currency_symbol}/m<sup>2</sup>
            </var>
          </span>
        );
      } else {
        return <></>;
      }
    } else if (unit === "currency/job") {
      const currencies = JSON.parse(sessionStorage.getItem("all_currencies"));
      const currency = sessionStorage.getItem("currency");
      const obj = currencies.find((x) => x.currency_symbol === currency);
      if (obj) {
        return (
          <span className="subscript-span">
            <var>{obj.currency_symbol}/job</var>
          </span>
        );
      } else {
        return <></>;
      }
    } else if (unit === "currency/kg") {
      const currencies = JSON.parse(sessionStorage.getItem("all_currencies"));
      const currency = sessionStorage.getItem("currency");
      const obj = currencies.find((x) => x.currency_symbol === currency);
      if (obj) {
        return (
          <span className="subscript-span">
            <var>{obj.currency_symbol}/kg</var>
          </span>
        );
      } else {
        return <></>;
      }
    } else if (unit === "currency/kW") {
      const currencies = JSON.parse(sessionStorage.getItem("all_currencies"));
      const currency = sessionStorage.getItem("currency");
      const obj = currencies.find((x) => x.currency_symbol === currency);
      if (obj) {
        return (
          <span className="subscript-span">
            <var>{obj.currency_symbol}/kW</var>
          </span>
        );
      } else {
        return <></>;
      }
    } else if (unit === "kW") {
      return <span className="subscript-span">kW</span>;
    } else if (unit === "m3") {
      return (
        <span className="subscript-span">
          <var>
            m<sup>3</sup>
          </var>
        </span>
      );
    } else if (unit === "m3/job") {
      return (
        <span className="subscript-span">
          <var>
            m<sup>3</sup>/job
          </var>
        </span>
      );
    } else if (unit === "cm3/h") {
      return (
        <span className="subscript-span">
          <var>
            cm<sup>3</sup>/h
          </var>
        </span>
      );
    } else if (unit === "currency/m3") {
      const currencies = JSON.parse(sessionStorage.getItem("all_currencies"));
      const currency = sessionStorage.getItem("currency");
      const obj = currencies.find((x) => x.currency_symbol === currency);
      if (obj) {
        return (
          <span className="subscript-span">
            <var>
              {obj.currency_symbol}/m<sup>3</sup>
            </var>
          </span>
        );
      } else {
        return <></>;
      }
    } else if (unit === "currency/cm3") {
      const currencies = JSON.parse(sessionStorage.getItem("all_currencies"));
      const currency = sessionStorage.getItem("currency");
      const obj = currencies.find((x) => x.currency_symbol === currency);
      if (obj) {
        return (
          <span className="subscript-span">
            <var>
              {obj.currency_symbol}/cm<sup>3</sup>
            </var>
          </span>
        );
      } else {
        return <></>;
      }
    } else if (unit === "currency/year") {
      const currencies = JSON.parse(sessionStorage.getItem("all_currencies"));
      const currency = sessionStorage.getItem("currency");
      const obj = currencies.find((x) => x.currency_symbol === currency);
      if (obj) {
        return (
          <span className="subscript-span">
            <var>{obj.currency_symbol}/year</var>
          </span>
        );
      } else {
        return <></>;
      }
    } else if (unit === "currency/hour" || unit === "currency/h") {
      const currencies = JSON.parse(sessionStorage.getItem("all_currencies"));
      const currency = sessionStorage.getItem("currency");
      const obj = currencies.find((x) => x.currency_symbol === currency);
      if (obj) {
        return (
          <span className="subscript-span">
            <var>{obj.currency_symbol}/hr</var>
          </span>
        );
      } else {
        return <></>;
      }
    } else if (unit === "h") {
      return <span className="subscript-span">h</span>;
    } else if (unit === "jobs") {
      return <span className="subscript-span">jobs</span>;
    }
  };
  const renderRetroJobs = () => {
    let flagCounter = 0;
    return (
      // eslint-disable-next-line
      tempHetrogeneousJobs.map((hetroJobs, index) => {
        // console.log("hetroJobs", hetroJobs);
        if (technologyName === "Polymer Simulation") {
          if (index % 2 === 0) {
            flagCounter += 1;
          }
          return (
            <>
              {index % 2 === 0 && (
                <div className="hr w-100 mt-36">
                  <div className="field mb-12">
                    <p className="field-heading">Part {flagCounter + 1}</p>
                  </div>
                </div>
              )}
              <div className="field-wrapper flex-item">
                <div
                  className={
                    primaryFields.includes(hetroJobs.name)
                      ? "field-label"
                      : "field-label-secondary"
                  }
                >
                  <div className="field">
                    <p data-tip={hetroJobs.field_info}>
                      {hetroJobs.name}
                      {isRequiredField(hetroJobs.name, stepId) && (
                        <RequiredMark />
                      )}
                    </p>
                    {renderTooltip(hetroJobs)}
                  </div>
                </div>
                <div className="field-input">
                  <div
                    className="table-inputbox"
                    style={{ position: "relative" }}
                  >
                    <input
                      type="text"
                      className="login-input"
                      name={hetroJobs.keys}
                      id={flagCounter}
                      style={{
                        width: hetroJobs?.field_unit ? "90%" : "100%",
                      }}
                      value={
                        formFields[constant.HETROGENEOUS] &&
                        formFields[constant.HETROGENEOUS][flagCounter] !==
                          undefined
                          ? formFields[constant.HETROGENEOUS][flagCounter][
                              hetroJobs.keys
                            ]
                          : ""
                      }
                      onChange={(e) => {
                        getFieldValues(e, true, true);
                      }}
                    />

                    {renderSubscript(hetroJobs.field_unit)}
                    {hetroJobs.is_override_enabled && <OverrideAbleTip />}
                  </div>
                </div>
              </div>
            </>
          );
        } else {
          if (index % 3 === 0) {
            flagCounter += 1;
          }
          return (
            <React.Fragment key={`${hetroJobs.name}-${index}`}>
              {index % 3 === 0 && (
                <div className="hr w-100 mt-36">
                  <div className="field mb-12">
                    <p className="field-heading">Part {flagCounter + 1}</p>
                  </div>
                </div>
              )}
              <div className="field-wrapper flex-item">
                <div
                  className={
                    primaryFields.includes(hetroJobs.name)
                      ? "field-label"
                      : "field-label-secondary"
                  }
                >
                  <div className="field">
                    <p data-tip={hetroJobs.field_info}>
                      {hetroJobs.name}
                      {isRequiredField(hetroJobs.name, stepId) && (
                        <RequiredMark />
                      )}
                    </p>
                    {renderTooltip(hetroJobs)}
                  </div>
                </div>
                <div className="field-input">
                  <div
                    className="table-inputbox"
                    style={{ position: "relative" }}
                  >
                    <input
                      type="text"
                      className="login-input"
                      name={hetroJobs.keys}
                      id={flagCounter}
                      style={{
                        width: hetroJobs?.field_unit ? "90%" : "100%",
                      }}
                      value={
                        formFields[constant.HETROGENEOUS] &&
                        formFields[constant.HETROGENEOUS][flagCounter] !==
                          undefined
                          ? formFields[constant.HETROGENEOUS][flagCounter][
                              hetroJobs.keys
                            ]
                          : ""
                      }
                      onChange={(e) => {
                        getFieldValues(e, true, true);
                      }}
                    />
                    {renderSubscript(hetroJobs.field_unit)}
                    {hetroJobs.is_override_enabled && <OverrideAbleTip />}
                  </div>
                </div>
              </div>
            </React.Fragment>
          );
        }
      })
    );
  };

  const renderOptions = (data_reference_type) => {
    if (data_reference_type === "Machine") {
      // Getting Fields by Step Id
      client
        .query({
          query: constant.GET_MACHINES,
          variables: {
            technology_id: technologyId,
            calculator_type: calculatorType,
          },
        })
        .then((res) => {
          const options_array = [];
          for (
            let index = 0;
            index < res.data.getClientMachineByTechnology.length;
            index++
          ) {
            options_array.push({
              id: res.data.getClientMachineByTechnology[index].machine_id,
              name: res.data.getClientMachineByTechnology[index].name,
              data_for_cost:
                res.data.getClientMachineByTechnology[index]
                  .is_data_avail_for_cost,
              data_for_carbon:
                res.data.getClientMachineByTechnology[index]
                  .is_data_avail_for_carbon,
            });
          }
          setMachineOptions(options_array);
        })
        .catch((error) => {
          // toast.error(error.graphQLErrors[0].messasge.message)
        });
      //
    } else if (data_reference_type === "Material") {
      let group_id = +sessionStorage.getItem("group_id");

      // Getting Fields by Step Id
      client
        .query({
          query: constant.GET_MATERIALS,
          variables: {
            machine_id: parseInt(formFields["machine_id"].value),
            group_id,
            calculator_type: calculatorType,
          },
        })
        .then((res) => {
          const options_array = [];
          for (
            let index = 0;
            index < res.data.getClientMaterialByMachineId.length;
            index++
          ) {
            options_array.push({
              id: res.data.getClientMaterialByMachineId[index].material_id,
              name: res.data.getClientMaterialByMachineId[index].name,
              material_data_for_cost:
                res.data.getClientMaterialByMachineId[index]
                  .is_data_avail_for_cost,
              material_data_for_carbon:
                res.data.getClientMaterialByMachineId[index]
                  .is_data_avail_for_carbon,
            });
          }
          setMaterialtOptions(options_array);
        })
        .catch((error) => {
          // toast.error(error.graphQLErrors[0].messasge.message)
        });
      //
    } else if (data_reference_type === "Parameter") {
      // Getting Fields by Step Id
      client
        .query({
          query: constant.GET_PARAMETERS,
          variables: {
            machine_id: parseInt(formFields["machine_id"].value),
            material_id: parseInt(formFields["material_id"].value),
          },
        })
        .then((res) => {
          const options_array = [];
          if (!!res?.data?.getClientParemeterByMMIds?.length) {
            for (
              let index = 0;
              index < res.data.getClientParemeterByMMIds.length;
              index++
            ) {
              if (
                technologyName === "Metal Estimation" ||
                technologyName === "Metal Simulation" ||
                technologyName === "Polymer Simulation"
              ) {
                options_array.push({
                  id: res.data.getClientParemeterByMMIds[index].paremeter_id,
                  name: res.data.getClientParemeterByMMIds[index].name,
                });
              } else {
                options_array.push({
                  core_id:
                    res.data.getClientParemeterByMMIds[index].paremeter_id,
                  id: res.data.getClientParemeterByMMIds[index].name,
                  name: res.data.getClientParemeterByMMIds[index].name,
                });
              }
            }
          } else {
            setFieldDataAvailability(true);
          }
          setParametersOptions(options_array);
        })
        .catch((error) => {
          // toast.error(error.graphQLErrors[0].messasge.message)
        });
      //
    } else if (data_reference_type === "Parameter.fill_rate_type") {
      // Getting Fields by Step Id
      client
        .query({
          query: constant.GET_FILL_RATES,
          variables: {
            machine_id: parseInt(formFields["machine_id"].value),
            material_id: parseInt(formFields["material_id"].value),
            parameter_name: formFields["parameter_name"].value,
          },
        })
        .then((res) => {
          const options_array = [];
          for (
            let index = 0;
            index < res.data.getClientFillRates.length;
            index++
          ) {
            options_array.push({
              id: res.data.getClientFillRates[index].paremeter_id,
              fill_rate_type: res.data.getClientFillRates[index].fill_rate_type,
            });
          }
          setFillRateOptions(options_array);
        })
        .catch((error) => {
          // toast.error(error.graphQLErrors[0].messasge.message)
        });
      //
    } else if (data_reference_type === "Filters") {
      // Getting Fields by Step Id
      client
        .query({
          query: constant.GET_FILTERS,
          variables: { machine_id: +formFields.machine_id.value },
        })
        .then((res) => {
          const options_array = [];
          for (
            let index = 0;
            index < res.data.getClientFilters.length;
            index++
          ) {
            options_array.push({
              id: res.data.getClientFilters[index].filter_id,
              name: res.data.getClientFilters[index].name,
            });
          }
          const fields = formFields;
          fields["filter_id"] = {
            value: options_array[0].id,
            override: false,
          };
          setFormFields({ ...formFields, ...fields });
          setFilterOptions(options_array);
        })
        .catch((error) => {
          // toast.error(error.graphQLErrors[0].messasge.message)
        });
      //
    } else if (data_reference_type === "Recoater_Blade") {
      // Getting Fields by Step Id
      client
        .query({
          query: constant.GET_RECOATER_BLADES,
          variables: { machine_id: +formFields.machine_id.value },
        })
        .then((res) => {
          const options_array = [];
          for (
            let index = 0;
            index < res.data.getClientRacoaterBlades.length;
            index++
          ) {
            options_array.push({
              id: res.data.getClientRacoaterBlades[index].racoater_blade_id,
              name: res.data.getClientRacoaterBlades[index].recoater_blade_name,
            });
          }
          const fields = formFields;
          fields["recoater_blade_id"] = {
            value: options_array[0].id,
            override: false,
          };
          setFormFields({ ...formFields, ...fields });
          setRecoaterBladeOptions(options_array);
        })
        .catch((error) => {
          // toast.error(error.graphQLErrors[0].messasge.message)
        });
    } else if (data_reference_type === "Inert_Gas") {
      // Getting Fields by Step Id
      client
        .query({
          query: constant.GET_INERT_GAS,
          variables: {},
        })
        .then((res) => {
          const options_array = [];
          for (
            let index = 0;
            index < res.data.getClientInertGas.length;
            index++
          ) {
            options_array.push({
              id: res.data.getClientInertGas[index].gas_id,
              name: res.data.getClientInertGas[index].name,
            });
          }
          const fields = formFields;
          fields["select_inert_gas"] = {
            value: options_array[0].id,
            override: false,
          };
          setFormFields({ ...formFields, ...fields });
          setInertGasOptions(options_array);
        })
        .catch((error) => {
          // toast.error(error.graphQLErrors[0].messasge.message)
        });
    } else if (data_reference_type === "Build_Platform") {
      // Getting Fields by Step Id
      client
        .query({
          query: constant.GET_BUILD_PLATFORM,
          variables: { machine_id: +formFields.machine_id.value },
        })
        .then((res) => {
          const options_array = [];
          for (
            let index = 0;
            index < res.data.getClientBuildPlatforms.length;
            index++
          ) {
            options_array.push({
              id: res.data.getClientBuildPlatforms[index].build_platform_id,
              name: res.data.getClientBuildPlatforms[index].build_platform_name,
            });
          }
          const fields = formFields;
          fields["build_platform_id"] = {
            value: options_array[0].id,
            override: false,
          };
          setFormFields({ ...formFields, ...fields });
          setBuildPlatformOptions(options_array);
        })
        .catch((error) => {
          // toast.error(error.graphQLErrors[0].messasge.message)
        });
    }
  };

  const handleSection = () => {
    if (fieldDataAvailability) {
      toast.error(RESPONSE_MESSAGES?.VALUES_NOT_AVAILABLE);
      return;
    }
    const fieldsErrors = document.getElementsByClassName("error-messages");
    for (let index = 0; index < fieldsErrors.length; index++) {
      fieldsErrors[index].style.display = "none";
    }
    let array = formFields;
    for (let index = 0; index < stepFields.length; index++) {
      if (
        formFields[stepFields[index].keys] === undefined &&
        stepFields[index].is_optional === false &&
        stepFields[index].field_input_type !== "label_section" &&
        stepFields[index].field_input_type !== "label" &&
        stepFields[index].field_input_type !== "enable_multiple_rows" &&
        stepFields[index].renderer === 2
      ) {
        document.getElementById(
          `error-${stepFields[index].keys}`,
        ).style.display = "block";
        return;
      } else if (
        formFields[stepFields[index].keys] === undefined &&
        stepFields[index].is_optional === true
      ) {
        if (stepFields[index].field_data_type !== "string") {
          array[stepFields[index].keys] = { value: 0, override: false };
        } else {
          array[stepFields[index].keys] = { value: "", override: false };
        }
      }
    }
    setFormFields({ ...formFields, ...array });
    // Navigate to next step by index in techSteps (ids may be non-sequential)
    const currentIndex = techSteps.findIndex((x) => x.step_id === stepId);
    console.log(currentIndex);
    if (currentIndex !== -1 && currentIndex + 1 < techSteps.length) {
      const nextStepId = techSteps[currentIndex + 1].step_id;
      handlestep(nextStepId);
    }
  };

  const getFieldValues = (
    e,
    flagForChange = true,
    retro = false,
    fieldType = "number",
    override = false,
    notInArray = false,
    isCostOfPowerKW = false,
  ) => {
    unRegisterSocketEvents();
    let emptyString = false;
    if (flagForChange) {
      let { name, value } = e.target;
      if (name === "material_id") {
        let result = material_options?.find(
          (material) => material.id === +value,
        );
        sessionStorage.setItem("materials", result?.material_data_for_carbon);
      }
      if (name === "machine_id") {
        let result = machine_options?.find((machine) => machine.id === +value);
        sessionStorage.setItem("machines", result?.data_for_carbon);
      }
      if (!isCostOfPowerKW) {
        if (
          parseInt(value.toString().charAt(0)) === 0 &&
          !value.toString().includes(".")
        ) {
          if (parseInt(value) === 0) {
            value = 0;
          } else {
            value = value.substring(1, value.length);
          }
        }
      }
      if (fieldType === "number") {
        // Checking field type and value to be fill in main object field...
        // console.log("Field Type number", fieldType);
        // console.log("Value", value);
        if (value === "") {
          value = 0;
        }
        if (isNaN(value)) {
          // console.log("Value NAN");
          emptyString = true;
          e.preventDefault();
          return;
        }
      }
      value = normalizeIncomingFieldValue(name, value, fieldType);
      if (retro) {
        const retroObjArray =
          formFields[constant.HETROGENEOUS] === undefined
            ? []
            : formFields[constant.HETROGENEOUS];

        let customRetroObj = retroObjArray.find((x) => x.id === e.target.id);

        if (customRetroObj) {
          customRetroObj["id"] = e.target.id;
          customRetroObj[e.target.name] = e.target.value;
          retroObjArray[retroObjArray.findIndex((x) => x.id === e.target.id)] =
            customRetroObj;
          if (name === "part_volume") {
            let part_total_volume = 0;
            for (let index = 0; index < retroObjArray.length; index++) {
              part_total_volume += parseInt(retroObjArray[index].part_volume);
            }

            let array = formFields;
            array["part_total_volume"] = {
              value: +part_total_volume,
              override: false,
            };
          } else if (name === "no_of_parts") {
            let total_no_of_parts = 0;
            for (let index = 0; index < retroObjArray.length; index++) {
              total_no_of_parts += parseInt(retroObjArray[index].no_of_parts);
            }
            let array = formFields;
            // Total array of current selected tech....
            // console.log("Array in Get field: ", array);
            array["total_no_of_parts"] = {
              value: total_no_of_parts,
              override: false,
            };

            // console.log("Before Set Array in Get field: ", array);
            // console.log("Before Set Array in Get field: ", formFields);

            setFormFields({ ...formFields, ...array });
            // console.log(" After Array in Get field: ", array);
            // console.log("After Set Array in Get field: ", formFields);
          } else if (name === "part_support_volume") {
            let total_part_support_volume = 0;
            for (let index = 0; index < retroObjArray.length; index++) {
              total_part_support_volume += parseInt(
                retroObjArray[index].part_support_volume,
              );
            }
            let array = formFields;
            // Total array of current selected tech....
            // console.log("Array in Get field: ", array);
            array["total_part_support_volume"] = {
              value: total_part_support_volume,
              override: false,
            };

            // console.log("Before Set Array in Get field: ", array);
            // console.log("Before Set Array in Get field: ", formFields);

            setFormFields({ ...formFields, ...array });
            // console.log(" After Array in Get field: ", array);
            // console.log("After Set Array in Get field: ", formFields);
          }
        } else {
          customRetroObj = {};
          customRetroObj["id"] = e.target.id;
          customRetroObj[e.target.name] = e.target.value;
          retroObjArray.push(customRetroObj);
          if (name === "part_volume") {
            let array = formFields;
            array["part_total_volume"] = {
              value: +e.target.value,
              override: false,
            };
            setFormFields({ ...formFields, ...array });
          } else if (name === "no_of_parts") {
            let array = formFields;
            array["total_no_of_parts"] = {
              value: e.target.value,
              override: false,
            };
            setFormFields({ ...formFields, ...array });
          }
        }
        let array = formFields;
        array[constant.HETROGENEOUS] = retroObjArray;
        if (notInArray) {
          array[name] =
            name !== "part_name" &&
            name !== "company_name" &&
            name !== "parameter_name"
              ? { value: value, override: true }
              : { value, override: true };
        }
        setFormFields({ ...formFields, ...array });
      } else if (override) {
        // OverRide able fields....
        // console.log("Over Rides");
        if (value !== "" && value !== undefined && value.length !== 0) {
          let array = formFields;

          array[name] =
            name !== "part_name" &&
            name !== "company_name" &&
            name !== "parameter_name"
              ? { value: value, override: true }
              : { value, override: true };
          setFormFields({ ...formFields, ...array });
          if (
            name === FIELD_NAMES?.MISCELLANEOUS ||
            name === FIELD_NAMES?.SERVICE_EXPENSE ||
            name === FIELD_NAMES?.SOFTWARE_EXPENSE
          ) {
            const serviceExpense =
              parseInt(array[FIELD_NAMES?.SERVICE_EXPENSE]?.value || 0) || 0;
            const softwareExpense =
              parseInt(array[FIELD_NAMES?.SOFTWARE_EXPENSE]?.value || 0) || 0;
            const miscellaneous =
              parseInt(array[FIELD_NAMES?.MISCELLANEOUS]?.value || 0) || 0;
            const recurring_expense =
              serviceExpense + softwareExpense + miscellaneous;
            array[FIELD_NAMES?.RECURRING_EXPENSE] = {
              value: recurring_expense,
              override: true,
            };
            array[FIELD_NAMES?.SERVICE_EXPENSE] = {
              value: serviceExpense,
              override: true,
            };
            setFormFields({ ...formFields, ...array });
          }
          if (
            sessionStorage.getItem("technologyName") === "Metal (Estimation)"
          ) {
            let array = formFields;
            if (name === "no_of_parts") {
              array["total_no_of_parts"] = { value: value, override: false };
              setFormFields({ ...formFields, ...array });
            }
          }
        }
      } else {
        if (value !== "" && value !== undefined && value.length !== 0) {
          let array = formFields;
          array[name] =
            name !== "part_name" &&
            name !== "company_name" &&
            name !== "parameter_name"
              ? { value: value, override: false }
              : { value, override: false };
          if (name === "machine_id") {
            renderOptions("Material");
            formFields["material_id"] = -1;
            formFields["parameter_id"] = -1;
          }
          if (name === "material_id") {
            renderOptions("Parameter");
            formFields["parameter_id"] = -1;
          }
          if (name === "parameter_name") {
            renderOptions("Parameter.fill_rate_type");
            const obj = parameters_options.find((x) => x.name === value);
            formFields["parameter_id"] = {
              override: false,
              value: obj.core_id,
            };
          }
          setFormFields({ ...formFields, ...array });
        } else {
          if (name === "part_name") {
            formFields["part_name"] = "";
          }
          if (name === "company_name") {
            formFields["company_name"] = "";
          }
        }
      }
      if (!emptyString) {
        registerSocketEvents();

        const filteredFields = stepFields.filter(
          (x) => x.field_type === "database" || x.field_type === "calculated",
        );
        // Step Fields after Register Socket
        // console.log("Step Fields after Register Socket", filteredFields);

        computeFields(filteredFields, override);
      }
    } else {
      registerSocketEvents();
      const filteredFields = stepFields.filter(
        (x) => x.field_type === "database" || x.field_type === "calculated",
      );
      computeFields(filteredFields, override);
    }
  };

  // console.log("GET FIELD VALUE: ", getFieldValues());

  const registerSocketEvents = () => {
    socketObj.removeAllListeners();
    socketObj.on("connect", () => {
      console.log("Connected Socket in Register Socket Event");
    });
    socketObj.on("disconnect", () => {
      console.log("disconnect Socket in Register Socket Event");
    });
    socketObj.on("*", (event, data) => {
      if (event && event.data && event.data.length > 0) {
        const fieldObj = stepFields.find((x) => x.formula === event.data[0]);
        if (
          event.data[1] &&
          event.data[1].data &&
          event.data[1].data.type === "FIELD_CHANGE"
        ) {
          const index = stepFields.findIndex(
            (x) => x.field_id === parseInt(event.data[1].data.data),
          );
          if (index !== -1) {
            let array = stepFields;
            let array_index = array.findIndex(
              (x) => x.formula === event.data[1].data.previous_formula,
            );
            if (array_index !== -1) {
              array[array_index].formula = event.data[1].data.formula;
              array[array_index].formula_inputs =
                event.data[1].data.formula_inputs;
              array[array_index].loader = false;
            }
            array[index].renderer = 2;
            setStepFields([...array]);
            // fields filled with values...
            // console.log("Step Fields", array);
          }
        } else {
          // if ( TODO: Logic removed for Cpp part as per client requirement
          //   event.data[0] === "FO-CPP-HETRO" ||
          //   event.data[0] === "FO-CPP-HETRO2"
          // ) {
          //   let array = formFields;
          //   if (!array["cpp_part"]?.override) {
          //     if (event?.data[1]?.data?.value?.length === 1) {
          //       array["cpp_part_1"] = {
          //         value: event.data[1].data?.value[0],
          //         override: false,
          //       };
          //       array["cpp_part"] = {
          //         value: event.data[1].data?.value[0],
          //         override: false,
          //       };
          //     } else {
          //       for (let index = 0; index < event.data[1].data.value?.length; index++) {
          //         array[`cpp_part_${index + 1}`] = {
          //           value: event.data[1].data?.value[index],
          //           override: false,
          //         };
          //       }
          //     }
          //   }
          //   setFormFields({ ...formFields, ...array });
          //   const fieldIndex = stepFields.findIndex(
          //     (x) => x.formula === event.data[0]
          //   );
          //   if (fieldIndex !== -1) {
          //     let array = stepFields;
          //     array[fieldIndex].loader = false;
          //     setStepFields([...array]);
          //   }
          //   if (socketArray.length > 0) {
          //     const socketIndex = socketArray.findIndex(
          //       (x) => x.formula === event.data[0]
          //     );
          //     if (socketIndex !== -1) {
          //       socketArray.splice(socketIndex, 1);
          //     }
          //     if (socketArray.length > 0) {
          //       const fieldIndex = stepFields.findIndex(
          //         (x) => x.formula === socketArray[0].formula
          //       );
          //       if (fieldIndex !== -1) {
          //         let array = stepFields;
          //         array[fieldIndex].loader = false;
          //         setStepFields([...array]);
          //       }
          //       emitSocket(socketArray[0].formula, socketArray[0].data);
          //     }
          //   }
          // }
          if (fieldObj) {
            const fieldIndex = stepFields.findIndex(
              (x) => x.formula === event.data[0],
            );
            if (fieldIndex !== -1) {
              let array = stepFields;
              array[fieldIndex].loader = false;
              setStepFields([...array]);
            }
            const latestFormFields = formFieldsRef.current;
            if (
              !latestFormFields[fieldObj.keys] &&
              fieldObj.keys === "no_of_parts"
            ) {
              latestFormFields["no_of_parts"] = {
                value: event.data[1].data?.value,
                override: false,
              };
              latestFormFields["total_no_of_parts"] = {
                value: event.data[1].data?.value,
                override: false,
              };
            }
            if (
              fieldObj.keys === "no_of_parts" &&
              latestFormFields[fieldObj.keys] &&
              latestFormFields[fieldObj.keys].override === false
            ) {
              latestFormFields["no_of_parts"] = {
                value: event.data[1].data?.value,
                override: false,
              };
              latestFormFields["total_no_of_parts"] = {
                value: event.data[1].data?.value,
                override: false,
              };
            }
            if (
              !latestFormFields[fieldObj.keys] &&
              fieldObj.keys === "part_volume"
            ) {
              latestFormFields["part_volume"] = {
                value: event.data[1].data?.value,
                override: false,
              };
              latestFormFields["total_part_volume"] = {
                value: event.data[1].data?.value,
                override: false,
              };
            }
            if (
              fieldObj.keys === "part_volume" &&
              latestFormFields[fieldObj.keys] &&
              latestFormFields[fieldObj.keys].override === false
            ) {
              latestFormFields["part_volume"] = {
                value: event.data[1].data?.value,
                override: false,
              };
              latestFormFields["total_part_volume"] = {
                value: event.data[1].data?.value,
                override: false,
              };
            }
            if (!latestFormFields[fieldObj.keys]) {
              if (fieldObj?.is_customizable) {
                latestFormFields[fieldObj.keys] = {
                  value: event.data[1].data?.value,
                  override: false,
                  field_id: fieldObj?.field_id,
                  is_customizable: fieldObj?.is_customizable,
                };
              } else {
                latestFormFields[fieldObj.keys] = {
                  value: event.data[1].data?.value,
                  override: false,
                };
              }
            }
            if (
              latestFormFields[fieldObj.keys] &&
              latestFormFields[fieldObj.keys].override === false
            ) {
              if (fieldObj?.is_customizable) {
                latestFormFields[fieldObj.keys] = {
                  value: event.data[1].data?.value,
                  override: false,
                  field_id: fieldObj?.field_id,
                  is_customizable: fieldObj?.is_customizable,
                };
              } else {
                latestFormFields[fieldObj.keys] = {
                  value: event.data[1].data?.value,
                  override: false,
                };
              }
            }
            setFormFields({ ...latestFormFields });
            formFieldsRef.current = latestFormFields;
            const socketIndex = socketArray.findIndex(
              (x) => x.formula === event.data[0],
            );
            if (socketIndex !== -1) {
              socketArray.splice(socketIndex, 1);
            }

            // When System Cost Per Part updates, refresh System Cost Per cm³ next
            if (fieldObj.keys === "system_cost_per_part") {
              const cm3Field = stepFields.find(
                (x) => x.keys === "system_cost_per_cm3",
              );
              const cm3Formula = cm3Field?.formula;
              const cm3IsOverridden =
                !!formFields["system_cost_per_cm3"]?.override;

              if (cm3Formula && !cm3IsOverridden) {
                const alreadyQueued = socketArray.some(
                  (x) => x.formula === cm3Formula,
                );
                if (!alreadyQueued) {
                  socketArray.unshift({ formula: cm3Formula, data: undefined });
                }
              }
            }

            // When CPP Consumables updates, refresh Consumable Cost Per cm³ next
            if (fieldObj.keys === "cpp_consumables") {
              const cm3Field = stepFields.find(
                (x) => x.keys === "consumable_cost_per_cm3",
              );
              const cm3Formula = cm3Field?.formula;
              const cm3IsOverridden =
                !!formFields["consumable_cost_per_cm3"]?.override;

              if (cm3Formula && !cm3IsOverridden) {
                const alreadyQueued = socketArray.some(
                  (x) => x.formula === cm3Formula,
                );
                if (!alreadyQueued) {
                  socketArray.unshift({ formula: cm3Formula, data: undefined });
                }
              }
            }

            if (socketArray.length > 0) {
              const fieldIndex = stepFields.findIndex(
                (x) => x.formula === socketArray[0].formula,
              );
              if (fieldIndex !== -1) {
                let array = stepFields;
                array[fieldIndex].loader = true;
                setStepFields([...array]);
              }

              emitSocket(socketArray[0].formula, socketArray[0].data);
            }
          } else {
            console.log("Not Found", event);
          }
        }
      }
    });
  };
  const computeFields = (filteredFields, overrideEnabled) => {
    socketArray = [];

    setSocketArray(socketArray);
    if (overrideEnabled) {
      for (let index = 0; index < filteredFields.length; index++) {
        if (filteredFields[index].formula !== "") {
          socketArray.push({
            formula: filteredFields[index].formula,
            data: undefined,
          });
        }
      }
    } else {
      for (let index = 0; index < filteredFields.length; index++) {
        if (
          !socketArray.find((x) => x.formula === filteredFields[index].formula)
        ) {
          if (filteredFields[index].formula !== "") {
            socketArray.push({
              formula: filteredFields[index].formula,
              data: undefined,
            });
          }
        }
      }
    }
    if (socketArray.length > 0) {
      const fieldIndex = stepFields.findIndex(
        (x) => x.formula === socketArray[0].formula,
      );
      if (fieldIndex !== -1) {
        let array = stepFields;
        array[fieldIndex].loader = true;
        setStepFields([...array]);
      }
      emitSocket(socketArray[0].formula, socketArray[0].data);
    }
  };

  const renderMaterialDD = (field, textColor, setTextColor) => {
    return (
      <select
        className="table-inputbox1 myselect normal w-100"
        name={field.keys}
        style={{ color: textColor }}
        onChange={(e) => {
          setTextColor("#191919");
          getFieldValues(e, true, false, field.field_data_type);
        }}
      >
        <option value="-1" disabled selected hidden>
          Select {field.name}
        </option>
        {machine_options.length === 0
          ? renderOptions(field.data_reference)
          : ""}
        {machine_options.map((optionObj, index) => {
          return (
            <option
              value={optionObj.id}
              selected={
                formFields["machine_id"] &&
                optionObj.id === parseInt(formFields["machine_id"].value)
              }
            >
              {optionObj.name}
            </option>
          );
        })}
      </select>
    );
  };
  // console.log(formFields,"formFields")

  const renderMachineDD = (field) => {
    return (
      <select
        className={`table-inputbox1 myselect normal w-100 `}
        name={field.keys}
        onChange={(e) => {
          getFieldValues(e, true, false, field.field_data_type);
        }}
      >
        <option value="-1">Select {field.name}</option>
        {material_options.length === 0
          ? renderOptions(field.data_reference)
          : ""}
        {material_options.map((optionObj, index) => {
          return (
            <option
              value={optionObj.id}
              selected={
                formFields["material_id"] &&
                optionObj.id === parseInt(formFields["material_id"].value)
              }
            >
              {optionObj.name}
            </option>
          );
        })}
      </select>
    );
  };

  const renderParameterDD = (field) => {
    return (
      <select
        className="table-inputbox1 myselect normal"
        name={field.keys}
        onChange={(e) => {
          getFieldValues(e, true, false, field.field_data_type);
        }}
      >
        <option value="-1">Select {field.name}</option>
        {parameters_options.length === 0 && !fieldDataAvailability
          ? renderOptions(field.data_reference)
          : ""}
        {parameters_options.map((optionObj, index) => {
          return (
            <option
              value={optionObj.id}
              selected={
                formFields["parameter_id"] &&
                optionObj.id === parseInt(formFields["parameter_id"].value)
              }
            >
              {optionObj.name}
            </option>
          );
        })}
      </select>
    );
  };

  const renderFillRateDD = (field) => {
    return (
      <select
        className="table-inputbox1 myselect normal"
        name={field.keys}
        onChange={(e) => {
          getFieldValues(e, true, false, field.field_data_type);
        }}
      >
        <option value="-1">{field.name}</option>
        {fill_rate_options.length === 0
          ? renderOptions(field.data_reference)
          : ""}
        {fill_rate_options.map((optionObj, index) => {
          return (
            <option
              value={optionObj.id}
              selected={
                formFields["parameter_id"] &&
                optionObj.id === parseInt(formFields["parameter_id"].value)
              }
            >
              {optionObj.fill_rate_type}
            </option>
          );
        })}
      </select>
    );
  };

  const renderFilterDD = (field) => {
    return (
      <select
        className="table-inputbox1 myselect normal"
        name={field.keys}
        onChange={(e) => {
          getFieldValues(e, true, false, field.field_data_type);
        }}
      >
        <option value="-1">{field.name}</option>
        {filter_options.length === 0 ? renderOptions(field.data_reference) : ""}
        {filter_options.map((optionObj, index) => {
          return (
            <option
              value={optionObj.id}
              selected={
                formFields["filter_id"] &&
                optionObj.id === formFields["filter_id"].value
              }
            >
              {optionObj.name}
            </option>
          );
        })}
      </select>
    );
  };

  const renderRecoaterBladesDD = (field) => {
    return (
      <select
        className="table-inputbox1 myselect normal"
        name={field.keys}
        onChange={(e) => {
          getFieldValues(e, true, false, field.field_data_type);
        }}
      >
        <option value="-1">{field.name}</option>
        {recoater_blade_options.length === 0
          ? renderOptions(field.data_reference)
          : ""}
        {recoater_blade_options.map((optionObj, index) => {
          return (
            <option
              value={optionObj.id}
              selected={
                formFields["recoater_blade_id"] &&
                optionObj.id === formFields["recoater_blade_id"].value
              }
            >
              {optionObj.name}
            </option>
          );
        })}
      </select>
    );
  };

  const renderInertGasDD = (field) => {
    return (
      <select
        className="table-inputbox1 myselect normal"
        name={field.keys}
        onChange={(e) => {
          getFieldValues(e, true, false, field.field_data_type);
        }}
      >
        <option value="-1">{field.name}</option>
        {inert_gas_options.length === 0
          ? renderOptions(field.data_reference)
          : ""}
        {inert_gas_options.map((optionObj, index) => {
          return (
            <option
              value={optionObj.id}
              selected={
                formFields["select_inert_gas"] &&
                optionObj.id === formFields["select_inert_gas"].value
              }
            >
              {optionObj.name}
            </option>
          );
        })}
      </select>
    );
  };

  const renderBuildPlatformsDD = (field) => {
    // TODO
    return (
      <select
        className="table-inputbox1 myselect normal"
        name={field.keys}
        onChange={(e) => {
          getFieldValues(e, true, false, field.field_data_type);
        }}
      >
        <option value="-1">{field.name}</option>
        {build_platform_options.length === 0
          ? renderOptions(field.data_reference)
          : ""}
        {build_platform_options.map((optionObj, index) => {
          return (
            <option
              value={optionObj.id}
              selected={
                formFields["build_platform_id"] &&
                optionObj.id === formFields["build_platform_id"].value
              }
            >
              {optionObj.name}
            </option>
          );
        })}
      </select>
    );
  };

  const renderStackingDD = (field) => {
    return (
      <select
        className="table-inputbox1 myselect normal"
        name={field.keys}
        defaultValue={1}
        onChange={(e) => {
          getFieldValues(e, true, false, field.field_data_type);
        }}
      >
        <option value={1}>Yes</option>
        <option value={-1}>No</option>
      </select>
    );
  };

  const renderBatchFillingGrade = (field) => {
    // TODO
    return (
      <div>
        <select
          className="table-inputbox1 myselect normal"
          name={field.keys}
          onChange={(e) => {
            getFieldValues(e, true, false, field.field_data_type);
          }}
        >
          <option value="-1">{field.name}</option>
          <option value="80">Best (80%)</option>
          <option value="50">Regular (50%)</option>
          <option value="30">Worse (30%)</option>
        </select>
        <div onClick={() => setIsOpen(true)}>
          <img
            src="../assets/eye.png"
            alt=""
            height="18"
            width="27"
            className="no-hide batch-info"
          />
        </div>
      </div>
    );
  };

  const renderTooltip = (field) => {
    if (field.field_info !== "") {
      const isBlockiness = field.name === "Blockiness";
      return (
        <div className="field tooltip-p">
          <img src="../assets/InfoIcon.svg" alt="" height="16" width="16" />
          <span
            className="tooltiptext p-2"
            style={
              isBlockiness
                ? {
                    width: "256px",
                    boxSizing: "border-box",
                    paddingLeft: "8px",
                    paddingRight: "8px",
                  }
                : undefined
            }
          >
            {field.field_info}
            {isBlockiness && (
              <img
                src="../assets/blockiness_img.png"
                alt="Blockiness reference"
                style={{ width: "94%", margin: "6px auto 0", display: "block" }}
              />
            )}
          </span>
        </div>
      );
    }
  };

  const handleBack = () => {
    if (fieldDataAvailability) {
      setFieldDataAvailability(false);
    }
    // Navigate to previous step by index in techSteps (ids may be non-sequential)
    const currentIndex = techSteps.findIndex((x) => x.step_id === stepId);
    if (currentIndex > 0) {
      const prevStepId = techSteps[currentIndex - 1].step_id;
      handlestep(prevStepId);
    }
  };

  const saveFormFieldsInDb = (formData) => {
    toggleMutation({
      variables: { calculations: formData },
      optimisticResponse: true,
    })
      .then((res) => {})
      .catch((error) => {
        console.log("Getting error from server");
      });
  };

  const saveCustomizedField = (field) => {
    if (!savingCustomizedFieldLoading) {
      mutateFunction({
        variables: {
          machine_id: parseInt(formFields["machine_id"].value),
          region_id: parseInt(formFields["region_id"].value),
          technology_id: technologyId,
          field_id: field?.field_id,
          calculator_type: calculatorType,
          value: parseFloat(formFields[field?.keys].value),
          material_id: formFields?.material_id?.value
            ? parseInt(formFields?.material_id?.value)
            : null,
        },
        optimisticResponse: true,
      })
        .then((res) => {
          toast.success(RESPONSE_MESSAGES?.CUSTOMIZABLE_VALUE_SAVED);
          // Close the edit box after successful save
          openEditBox(field.field_id, false, field?.keys);
        })
        .catch((error) => {
          console.log("Getting error from server");
        });
    }
  };
  const resetCustomizedField = (field) => {
    if (!resettingFieldLoading) {
      mutateResetCustomizedField({
        variables: { field_id: field?.field_id },
        optimisticResponse: true,
      })
        .then((res) => {
          toast.success(RESPONSE_MESSAGES?.VALUES_RESET_DEFAULT);
          openEditBox(field.field_id, false, field?.keys);
        })
        .catch((error) => {
          toast.error(RESPONSE_MESSAGES?.VALUES_ALREACY_DEFAULT);
        });
    }
  };

  const RequiredMark = () => <span className="required">*</span>;
  const renderButtons = ({ hideBtn = false } = {}) => {
    const isCalculating =
      Array.isArray(stepFields) && stepFields.some((f) => f?.loader === true);
    const isRequiredFieldsFilled = areRequiredFieldsFilled(stepId, formFields);

    const isNextDisabled =
      !isRequiredFieldsFilled || isCalculating || !!fieldsLoader;
    // Determine position-based navigation
    const currentIndex = techSteps.findIndex((x) => x.step_id === stepId);
    const hasNext = currentIndex !== -1 && currentIndex < techSteps.length - 1;

    if (hasNext) {
      // Non-last steps: show Back (region-select on first) and Next
      const isFirst = currentIndex === 0;
      if (isFirst) {
        return (
          <div className="border-top mt-24">
            <div className="d-flex mx-80 my-12   justify-content-between">
              {hideBtn ? (
                <div></div>
              ) : (
                <>
                  <div className="d-flex ">
                    <div id="btn-row ">
                      <a
                        href="./region-select"
                        className="button1 button btn-black"
                      >
                        <p>Back</p>
                      </a>
                    </div>
                  </div>
                  <div>
                    <div id="btn-row">
                      <div
                        className={
                          "button1 button" +
                          (!isNextDisabled ? " btn-primary" : " btn-disabled")
                        }
                        onClick={() => {
                          if (!isNextDisabled) handleSection();
                        }}
                      >
                        {isCalculating ? (
                          <i className="fa fa-spinner fa-spin mr-2"></i>
                        ) : (
                          <p>Next</p>
                        )}
                      </div>
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>
        );
      }
      return (
        <>
          <div className="border-top mt-24">
            <div className="d-flex mx-80 my-12   justify-content-between">
              <div className="button1 button btn-black" onClick={handleBack}>
                <p>Back</p>
              </div>
              <div
                className={
                  "button1 button" +
                  (!isNextDisabled ? " btn-primary" : " btn-disabled")
                }
                onClick={() => {
                  if (!isNextDisabled) handleSection();
                }}
              >
                {isCalculating ? (
                  <i className="fa fa-spinner fa-spin mr-2"></i>
                ) : (
                  <p>Next</p>
                )}
              </div>
            </div>
          </div>
        </>
      );
    }

    // Last step: show Back and Visual Analytics
    return (
      <>
        <div className="border-top mt-24">
          <div className="d-flex mx-80 my-12   justify-content-between">
            <div className="button1 button btn-black" onClick={handleBack}>
              <p>Back</p>
            </div>
            <Link
              to="/calculator/visual-analytics/true"
              className={
                "button1 button" +
                (!isNextDisabled ? " btn-primary width-auto" : " btn-disabled")
              }
              style={{ columnGap: "8px" }}
              onClick={(e) => {
                if (isNextDisabled) {
                  e.preventDefault();
                  return;
                }
                socketObj.off("*");
                const estimationVerticle =
                  sessionStorage.getItem("technologyName") ===
                    "Metal (Estimation)" ||
                  sessionStorage.getItem("technologyName") ===
                    "Polymer (Estimation)";
                if (!estimationVerticle) {
                  const array = formFields;
                  const totalAmCpp = parseFloat(
                    parseFloat(formFields["system_cost_per_part"]?.value) +
                      estimationVerticle
                      ? 0
                      : parseFloat(
                            formFields["recurring_cost_per_part"]?.value,
                          ) +
                          parseFloat(
                            formFields["material_cost_per_part"]?.value,
                          ) +
                          estimationVerticle
                        ? 0
                        : parseFloat(formFields["cpp_consumables"]?.value),
                  );
                  array["total_am_cpp"] = {
                    value: totalAmCpp,
                    override: false,
                  };
                  setFormFields({ ...formFields, ...array });
                  const totalAmCm3 = parseFloat(
                    parseFloat(formFields["system_cost_per_cm3"]?.value) +
                      estimationVerticle
                      ? 0
                      : parseFloat(
                            formFields["recurring_cost_per_cm3"]?.value,
                          ) +
                          parseFloat(
                            formFields["material_cost_per_cm3"]?.value,
                          ) +
                          estimationVerticle
                        ? 0
                        : parseFloat(
                            formFields["consumable_cost_per_cm3"]?.value,
                          ),
                  );
                  array["total_am_cost_cm3"] = {
                    value: totalAmCm3,
                    override: false,
                  };
                  setFormFields({ ...formFields, ...array });
                }
                if (sessionStorage.getItem("calculator_values_names")) {
                  const calculator_values_multiple = JSON.parse(
                    sessionStorage.getItem("calculator_values_names"),
                  );
                  if (calculator_values_multiple?.length) {
                    for (const item of calculator_values_multiple) {
                      sessionStorage.removeItem(`calculator_values_${item}`);
                    }
                    sessionStorage.removeItem(`calculator_values_multiple`);
                  }
                }
                sessionStorage.setItem("scenario_name", "default");
                sessionStorage.setItem("stepId", stepId);
                sessionStorage.setItem(
                  "calculator_values_default",
                  JSON.stringify(formFields),
                );
                saveFormFieldsInDb(formFields);
                sessionStorage.removeItem("Analytics_Route");
              }}
            >
              {isCalculating ? (
                <i className="fa fa-spinner fa-spin mr-2"></i>
              ) : (
                <>
                  <img
                    alt=""
                    src="../assets/analytics.png"
                    width="22"
                    height="22"
                  />
                  <p>Visual Analytics</p>
                </>
              )}
            </Link>
          </div>
        </div>
      </>
    );
  };
  // const renderPermiumShow = () =>
  //   permiumField.map((item, index) => (
  //     <tr>
  //       <td className="permium-row" style={{ width: "100%" }}>
  //         {item.name}
  //         <a href="/premium-request" className="premium-row-text">
  //           Premium
  //         </a>
  //       </td>
  //       <td style={{ textAlign: "center" }}></td>
  //       <td></td>
  //     </tr>
  //   ));
  // TODO Code commented as not being used for now

  const renderLoader = (field) => {
    // console.log("Field: ", field)
    if (field.loader) {
      return (
        <img className="small-loader" src={Spinner} alt="loader" height="10%" />
      );
    } else {
      if (!(!field.is_premium || Access)) {
        return;
      }

      let value = 0;
      if (formFields[field.keys] === undefined) {
        if (
          field.field_type === "constant" ||
          field.keys === "labor_cost_per_hour"
        ) {
          let array = formFields;
          array[field.keys] = {
            value: parseFloat(field.data_reference),
            override: false,
          };

          setFormFields({ ...formFields, ...array });
        }
      } else {
        value = formFields[field.keys].value;
        if (field.name === "CPP Overhead & Consumables") {
          window.localStorage.setItem("CPP OC", formFields[field.keys].value);
          setOverHeadConsumables(formFields[field.keys].value);
        }
        // Field Name of each field to be used by user and value...
        // console.log("field check", field.name);
        // console.log("Value check", formFields[field.keys]);

        if (stepName === "System Cost") {
          checkArray1.push({
            name: field.name,
            value: formFields[field.keys].value,
          });
        }
        if (stepName === "Material Cost") {
          checkArray2.push({
            name: field.name,
            value: formFields[field.keys].value,
          });
        }
        if (stepName === "Post Processing") {
          checkArray3.push({
            name: field.name,
            value: formFields[field.keys].value,
          });
        }

        // if (stepName === "CPP Overhead & Consumables") {
        //   debugger
        // }
      }

      const subscript = renderSubscript(field.field_unit);

      if (field.field_unit.includes("currency")) {
        return (
          <p>
            {numberWithCommas(value)} {subscript}
          </p>
        );
      } else {
        return (
          <p>
            {value} {subscript}
          </p>
        );
      }
    }
  };

  const numberWithCommas = (x) => {
    if (x === 0) return 0;
    if (x) return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };

  const getUnitLabel = (unit) => {
    if (!unit) return "";

    unit = normalizeUnit(unit);
    if (unit === "cm3") {
      return "cm³";
    } else if (unit === "mm") {
      return "mm";
    } else if (unit === "currency") {
      const currencies = JSON.parse(
        sessionStorage.getItem("all_currencies") || "[]",
      );
      const currency = sessionStorage.getItem("currency");
      const obj = currencies.find((x) => x.currency_symbol === currency);
      return obj ? obj.currency_symbol : "";
    } else if (unit === "g/cm3") {
      return "g/cm³";
    } else if (unit === "year" || unit === "years") {
      return "year";
    } else if (unit === "%") {
      return "%";
    } else if (unit === "hours" || unit === "hour") {
      return "hours";
    } else if (unit === "hours/year") {
      return "hours/year";
    } else if (unit === "μm") {
      return "μm";
    } else if (unit === "mm/h") {
      return "mm/h";
    } else if (unit === "kg") {
      return "kg";
    } else if (unit === "m2") {
      return "m²";
    } else if (unit === "currency/m2") {
      const currencies = JSON.parse(
        sessionStorage.getItem("all_currencies") || "[]",
      );
      const currency = sessionStorage.getItem("currency");
      const obj = currencies.find((x) => x.currency_symbol === currency);
      return obj ? `${obj.currency_symbol}/m²` : "";
    } else if (unit === "currency/job") {
      const currencies = JSON.parse(
        sessionStorage.getItem("all_currencies") || "[]",
      );
      const currency = sessionStorage.getItem("currency");
      const obj = currencies.find((x) => x.currency_symbol === currency);
      return obj ? `${obj.currency_symbol}/job` : "";
    } else if (unit === "currency/kg") {
      const currencies = JSON.parse(
        sessionStorage.getItem("all_currencies") || "[]",
      );
      const currency = sessionStorage.getItem("currency");
      const obj = currencies.find((x) => x.currency_symbol === currency);
      return obj ? `${obj.currency_symbol}/kg` : "";
    } else if (unit === "currency/kW") {
      const currencies = JSON.parse(
        sessionStorage.getItem("all_currencies") || "[]",
      );
      const currency = sessionStorage.getItem("currency");
      const obj = currencies.find((x) => x.currency_symbol === currency);
      return obj ? `${obj.currency_symbol}/kW` : "";
    } else if (unit === "kW") {
      return "kW";
    } else if (unit === "m3") {
      return "m³";
    } else if (unit === "m3/job") {
      return "m³/job";
    } else if (unit === "cm3/h") {
      return "cm³/h";
    } else if (unit === "currency/m3") {
      const currencies = JSON.parse(
        sessionStorage.getItem("all_currencies") || "[]",
      );
      const currency = sessionStorage.getItem("currency");
      const obj = currencies.find((x) => x.currency_symbol === currency);
      return obj ? `${obj.currency_symbol}/m³` : "";
    } else if (unit === "currency/cm3") {
      const currencies = JSON.parse(
        sessionStorage.getItem("all_currencies") || "[]",
      );
      const currency = sessionStorage.getItem("currency");
      const obj = currencies.find((x) => x.currency_symbol === currency);
      return obj ? `${obj.currency_symbol}/cm³` : "";
    } else if (unit === "currency/year") {
      const currencies = JSON.parse(
        sessionStorage.getItem("all_currencies") || "[]",
      );
      const currency = sessionStorage.getItem("currency");
      const obj = currencies.find((x) => x.currency_symbol === currency);
      return obj ? `${obj.currency_symbol}/year` : "";
    } else if (unit === "currency/hour" || unit === "currency/h") {
      const currencies = JSON.parse(
        sessionStorage.getItem("all_currencies") || "[]",
      );
      const currency = sessionStorage.getItem("currency");
      const obj = currencies.find((x) => x.currency_symbol === currency);
      return obj ? `${obj.currency_symbol}/hr` : "";
    } else if (unit === "h") {
      return "h";
    } else if (unit === "jobs") {
      return "jobs";
    }

    return ""; // fallback
  };

  const primaryFields = [
    "Company Name",
    "Part Name",
    "Application",
    "System",
    "Material",
    "Parameter",
    "Material Price",
    "Material Density",
    "Additional Material Losses",
    "Build Rate",
    "Part Volume",
    "Part Support Volume",
    "No. of Parts",
    "Material density",
  ];
  const isXYZField = (name = "") => {
    const n = String(name).trim().toLowerCase();
    return n === "x" || n === "y" || n === "z";
  };
  const isStep39FillRate = (key) => stepId === 39 && key === "fill_rate";
  const getDisplayFieldValue = (fieldKey) => {
    const raw = formFields[fieldKey]?.value;
    if (!isStep39FillRate(fieldKey)) return raw ?? "";
    if (raw == null || raw === "" || raw === 0) return "";
    const num = typeof raw === "number" ? raw : Number(raw);
    if (!Number.isFinite(num)) return raw ?? "";
    const scaled = num * 100;
    return Number.isInteger(scaled)
      ? String(scaled)
      : String(Number(scaled.toFixed(2)));
  };
  const normalizeIncomingFieldValue = (fieldKey, incomingValue, fieldType) => {
    if (!isStep39FillRate(fieldKey)) return incomingValue;
    if (fieldType !== "number") return incomingValue;
    if (incomingValue === "" || incomingValue == null) return 0;
    const num =
      typeof incomingValue === "number" ? incomingValue : Number(incomingValue);
    if (!Number.isFinite(num)) return incomingValue;
    return num / 100;
  };
  const getSectionHeader = () => {
    if (stepId === 46 || stepId === 41 || stepId === 38 || stepId === 33) {
      return { text: "Part Information", showInfo: false };
    } else if (stepId === 47) {
      return { text: "Material Information", showInfo: false };
    } else if (stepId === 48) {
      return { text: "Post processing", showInfo: false };
    }
    else if (stepId === 39) {
      return { text: "Material Information", showInfo: false };
    }


    return { text: "Item", showInfo: false };
  };

  //Render the components on the base of key
  const renderComponents = () => {
    const firstLabelIndex = stepFields.findIndex(
      (x) => x.field_input_type === "label",
    );
    return (
      <>
        <div className=" container-form row p-0">
          <div className=" deadcenter justify-content-start">
            <div className="calcform calcform-wrapper">
              <table className="table calcform-top-btn mb-36 mt-36 ">
                <tbody>
                  {/* <tr>{renderButtons({ hideBtn: true })}</tr> */}
                  <tr>
                    <td style={{ width: "50%", padding: "0px !important" }}>
                      <div>
                        <div className="d-flex gap-12 mb-12">
                          <img
                            src="../assets/arrow-left.svg"
                            alt="bread-crumb arrow"
                            // height="32"
                            // width="32"
                          />
                          <span className="font-14 color-grey">
                            {step_type_id === 1
                              ? "Simple Part Cost Estimation"
                              : "Detailed Part Cost Estimation"}
                          </span>
                        </div>
                        <p className="font-24 font-semi-bold mb-12  ">
                          {stepName}
                        </p>
                        <p className="s-1">{technologyName}</p>
                        {/* {![42, 43, 44, 45].includes(stepId) && (
                          <p className="">
                            Textual fields for tracking, not mandatory
                          </p>
                        )} */}
                      </div>
                    </td>
                    <td></td>
                    <td>
                      {!Access && (
                        <a href="/premium-request">
                          <div id="btn-row mt-reset">
                            <div
                              className="text-center button-premium"
                              onClick={() => {}}
                            >
                              Click here to
                              <br />
                              <strong>
                                Access Premium now to unlock all features
                              </strong>
                            </div>
                          </div>
                        </a>
                      )}
                    </td>
                  </tr>
                </tbody>
              </table>

              {/* <table className="table ">
              <thead>
                <tr> */}
              {/* <th scope="col" colspan="3" > */}
              {(((stepId !== 44 && stepId !== 42  && stepId !== 43 && stepId !== 45 && stepId !== 89 && stepId !== 37 && stepId !== 87 && stepId !== 88) )) &&(
                <div className="d-flex flex-column gap-8 ">
                <span className="font-24 font-semi-bold">
                  {getSectionHeader().text}
                </span>
                {getSectionHeader().showInfo && (
                  <img
                    src="/assets/InfoIcon.svg"
                    alt="Info icon"
                    className="cursor-pointer"
                  />
                )}
                {[46,41,38].includes(stepId) && (
                          <p className="">
                            Textual fields for tracking, not mandatory
                          </p>
                        )}
                <div className="table-title-border"></div>
              </div>
              )}
              {/* </th>
                </tr>
              </thead> */}
              <div className="d-flex flex-wrap gap-20 mt-36">
                {
                  // eslint-disable-next-line
                  stepFields.map((field, index) => {
                    // Total Render Fields for full simulation...
                    // console.log("field", field);

                    if (field.field_input_type === "dropdown") {
                      return (
                        <div
                          key={field.field_id}
                          className={
                            "field-wrapper " +
                            (isXYZField(field.name)
                              ? " flex-item-xyz"
                              : "flex-item")
                          }
                        >
                          <div
                            className={
                              (primaryFields.includes(field.name)
                                ? "field-label "
                                : "field-label-secondary ") +
                              (!field.access ? "permium-row" : "")
                            }
                            // style={{ width: field.access ? "50%" : "100%" }}
                          >
                            {/* <div className="field"> */}
                            <p>
                              {field.name}
                              {isRequiredField(field.name, stepId) && (
                                <RequiredMark />
                              )}{" "}
                            </p>
                            {!field.is_premium || Access ? (
                              renderTooltip(field)
                            ) : (
                              <a
                                href="/premium-request"
                                className="premium-row-text"
                              >
                                Premium
                              </a>
                            )}
                            {/* </div> */}
                          </div>

                          <div className="field-input">
                            {(!field.is_premium || Access) && (
                              <>
                                {/* <div className="vcenter"> */}
                                {field.data_reference === "Machine"
                                  ? renderMaterialDD(
                                      field,
                                      textColor,
                                      setTextColor,
                                    )
                                  : ""}
                                {field.data_reference === "Material"
                                  ? renderMachineDD(field)
                                  : ""}
                                {field.data_reference === "Parameter" &&
                                formFields["material_id"] !== undefined
                                  ? renderParameterDD(field)
                                  : ""}
                                {field.data_reference ===
                                  "Parameter.fill_rate_type" &&
                                formFields["material_id"] !== undefined &&
                                formFields["parameter_name"] !== undefined
                                  ? renderFillRateDD(field)
                                  : ""}
                                {field.data_reference === "Filters"
                                  ? renderFilterDD(field)
                                  : ""}
                                {field.data_reference === "Recoater_Blade"
                                  ? renderRecoaterBladesDD(field)
                                  : ""}
                                {field.data_reference === "Inert_Gas"
                                  ? renderInertGasDD(field)
                                  : ""}
                                {field.data_reference === "Build_Platform"
                                  ? renderBuildPlatformsDD(field)
                                  : ""}
                                {field.data_reference === "Stacking"
                                  ? renderStackingDD(field)
                                  : ""}
                                {field.data_reference ===
                                  "Batch_Filling_Grade" && field.renderer === 2
                                  ? renderBatchFillingGrade(field)
                                  : ""}
                                {/* </div> */}
                                <span
                                  id={`error-${field.keys}`}
                                  className="error-messages"
                                >
                                  Please select {field.name}
                                </span>
                              </>
                            )}
                          </div>
                        </div>
                      );
                    } else if (field.field_input_type === "label") {
                      if (
                        hideFieldForHetrogenousJobs(
                          tempHetrogeneousJobs,
                          field.keys,
                        )
                      ) {
                        return null;
                      }

                      if (
                        (stepId === 41 || stepId === 33) &&
                        field.name?.toLowerCase() === "total job volume"
                      )
                        return (
                          <div className="job-volume-container">
                            <div
                              key={field.field_id}
                              className={
                                "field-wrapper d-flex w-100 flex-row align-items-center px-24 py-22"
                              }
                            >
                              <div className="job-volume-label">
                                <div className="field">
                                  <p>{field.name}</p>
                                </div>
                              </div>

                              <div className="d-flex" style={{ flex: 1 }}>
                                {(!field.is_premium || Access) && (
                                  <div className="field-input">
                                    <div className="input-wrapper">
                                      <div
                                        className="table-inputbox2 p-0 m-0 text-white "
                                        style={{ background: "transparent" }}
                                      >
                                        <input
                                          id={`input-${field.field_id}`}
                                          type="text"
                                          value={
                                            formFields[field.keys]?.value === 0
                                              ? ""
                                              : (formFields[field.keys]
                                                  ?.value ?? "")
                                          }
                                          disabled={!field.is_override_enabled}
                                          className="login-input text-white"
                                          name={field.keys}
                                          onChange={(e) =>
                                            getFieldValues(
                                              e,
                                              true,
                                              false,
                                              field.field_data_type,
                                              true,
                                            )
                                          }
                                        />
                                        {renderSubscript(field.field_unit)}
                                      </div>
                                    </div>
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                        );

                      return (
                        <>
                          {/* first step */}
                          {/* {stepId === 46 && index === firstLabelIndex && (
                            <div className="label-top-divider"></div>
                          )} */}
                         
                          <div
                            key={field.field_id}
                            className={
                              "field-wrapper " +
                              (isXYZField(field.name)
                                ? " flex-item-xyz"
                                : "flex-item")
                            }
                          >
                            <div
                              className={
                                (stepId === 47 && field.name === "Part Volume"
                                  ? "field-label-secondary "
                                  : primaryFields.includes(field.name)
                                    ? "field-label "
                                    : "field-label-secondary ") +
                                (!field.access
                                  ? hideFieldForHetrogenousJobs(
                                      tempHetrogeneousJobs,
                                      field.keys,
                                    )
                                    ? ""
                                    : "permium-row"
                                  : "")
                              }
                            >
                              <div className="field">
                                <p>
                                  {field.name}
                                  {isRequiredField(field.name, stepId) && (
                                    <RequiredMark />
                                  )}{" "}
                                </p>
                                {!field.is_premium || Access ? (
                                  renderTooltip(field)
                                ) : (
                                  <a
                                    href="/premium-request"
                                    className="premium-row-text"
                                  >
                                    Premium
                                  </a>
                                )}
                                {(field.keys ===
                                  FIELD_NAMES?.RECURRING_EXPENSE ||
                                  field.keys ===
                                    FIELD_NAMES?.SERVICE_EXPENSE) &&
                                  (!field.is_premium || Access) && (
                                    <img
                                      id={`edit-${field.field_id}`}
                                      src="../assets/EditIcon.png"
                                      alt="Edit Recurring Expense"
                                      width="18"
                                      height="18"
                                      className="ml-8 cursor-pointer"
                                      onClick={() => {
                                        if (
                                          !subFieldsByFieldId ||
                                          !subFieldsByFieldId.length
                                        ) {
                                          getSubFieldsById(field.field_id);
                                        }
                                        openEditBox(
                                          field.field_id,
                                          true,
                                          field?.keys,
                                        );
                                      }}
                                    />
                                  )}
                              </div>
                            </div>

                            {/* <td
                              style={{
                                display: hideFieldForHetrogenousJobs(
                                  tempHetrogeneousJobs,
                                  field.keys
                                )
                                  ? "none"
                                  : "table-cell",
                                textAlign: "center",
                              }}
                            >
                              {renderLoader(field)}
                            </td> */}

                            <div
                              // className={
                              //   "field-label"+
                              //   hideFieldForHetrogenousJobs(tempHetrogeneousJobs, field.keys)
                              //     ? "hidden"
                              //     : ""
                              // }
                              className={
                                primaryFields.includes(field.name)
                                  ? "field-label "
                                  : "field-label-secondary "
                              }
                            >
                              {(!field.is_premium || Access) && (
                                <div className="field-input">
                                  {/* Main recurring field on the left */}
                                  <div
                                    className="input-wrapper"
                                    id={`input-wrapper-${field.field_id}`}
                                  >
                                    <div className="table-inputbox2">
                                      <span className="mirror">
                                        {getDisplayFieldValue(field.keys)}
                                      </span>
                                      {formFields[field.keys]?.value != null &&
                                        formFields[field.keys]?.value !== 0 &&
                                        formFields[field.keys]?.value !==
                                          "" && (
                                          <span className="mirror1">
                                            {getUnitLabel(field.field_unit)}
                                          </span>
                                        )}
                                      <input
                                        id={`input-${field.field_id}`}
                                        type="text"
                                        disabled={!field.is_override_enabled}
                                        value={getDisplayFieldValue(field.keys)}
                                        placeholder={getUnitLabel(
                                          field.field_unit,
                                        )}
                                        className="login-input"
                                        style={{
                                          position:
                                            formFields[field.keys]?.value !=
                                              null &&
                                            formFields[field.keys]?.value !==
                                              0 &&
                                            formFields[field.keys]?.value !== ""
                                              ? "absolute"
                                              : "relative",
                                        }}
                                        name={field.keys}
                                        onChange={(e) =>
                                          getFieldValues(
                                            e,
                                            true,
                                            false,
                                            field.field_data_type,
                                            true,
                                          )
                                        }
                                      />
                                    </div>
                                    {field.is_override_enabled && (
                                      <OverrideAbleTip />
                                    )}
                                  </div>

                                  {/* Edit box on the right */}
                                  {(field?.keys ===
                                    FIELD_NAMES?.RECURRING_EXPENSE ||
                                    field?.keys ===
                                      FIELD_NAMES?.SERVICE_EXPENSE) && (
                                    <div
                                      id={`div-${field.field_id}`}
                                      className="hidden w-auto"
                                      style={{
                                        flexDirection: "column",
                                        height: "auto",
                                        gap: "10px",
                                      }}
                                    >
                                      {!!subFieldsByFieldId &&
                                      subFieldsByFieldId.length > 0 ? (
                                        subFieldsByFieldId?.map(
                                          (item, itemIndex) => {
                                            return (
                                              <div
                                                key={itemIndex}
                                                className="d-flex flex-column"
                                              >
                                                <p className="overrideable-input">
                                                  {item?.name}
                                                </p>
                                                <div className="table-inputbox2 mr-0">
                                                  <input
                                                    id={`input-${item.field_id}`}
                                                    type="text"
                                                    value={
                                                      formFields[
                                                        item?.name
                                                          ?.toLowerCase()
                                                          ?.replace(" ", "_")
                                                      ] !== undefined &&
                                                      formFields[
                                                        item?.name
                                                          ?.toLowerCase()
                                                          ?.replace(" ", "_")
                                                      ].override === true
                                                        ? formFields[
                                                            item?.name
                                                              ?.toLowerCase()
                                                              ?.replace(
                                                                " ",
                                                                "_",
                                                              )
                                                          ].value
                                                        : ""
                                                    }
                                                    className="login-input"
                                                    defaultValue="0"
                                                    name={item?.name
                                                      ?.toLowerCase()
                                                      ?.replace(" ", "_")}
                                                    onChange={(e) => {
                                                      getFieldValues(
                                                        e,
                                                        true,
                                                        false,
                                                        item.field_data_type,
                                                        true,
                                                      );
                                                    }}
                                                  />
                                                </div>
                                              </div>
                                            );
                                          },
                                        )
                                      ) : (
                                        <img
                                          className="small-loader"
                                          src={Spinner}
                                          alt="loader"
                                          height="10%"
                                        />
                                      )}
                                      {field?.is_customizable && (
                                        <>
                                          <img
                                            id={`save-${field.field_id}`}
                                            src="../assets/save.png"
                                            alt="Save"
                                            width="18"
                                            height="18"
                                            className="hidden cursor-pointer mt-8 ml-2"
                                            onClick={() =>
                                              saveCustomizedField(field)
                                            }
                                            title="Click icon to save your value"
                                          />
                                          <img
                                            id={`restore-${field.field_id}`}
                                            src="../assets/restore.png"
                                            alt="Restore"
                                            width="18"
                                            height="18"
                                            className="hidden cursor-pointer mt-8 ml-2"
                                            onClick={() =>
                                              resetCustomizedField(field)
                                            }
                                            title="Click to restore System value"
                                          />
                                        </>
                                      )}
                                      <img
                                        id={`cross-${field.field_id}`}
                                        src="../assets/cross.png"
                                        alt="Close"
                                        width="18"
                                        height="18"
                                        className="hidden cursor-pointer mt-8 ml-2"
                                        onClick={() => {
                                          openEditBox(
                                            field.field_id,
                                            false,
                                            field?.keys,
                                          );
                                        }}
                                        title="Close"
                                      />
                                    </div>
                                  )}
                                </div>
                              )}
                            </div>
                          </div>
                        </>
                      );
                    } else if (field.field_input_type === "multiple_labels") {
                      return (
                        <tr>
                          <td
                            className={
                              "" + (!field.access ? "permium-row" : "")
                            }
                            style={{ width: field.access ? "50%" : "100%" }}
                          >
                            <div className="field">
                              <p>{field.name}</p>
                              {!field.is_premium || Access ? (
                                renderTooltip(field)
                              ) : (
                                <a
                                  href="/premium-request"
                                  className="premium-row-text"
                                >
                                  Premium
                                </a>
                              )}
                            </div>
                          </td>
                          <td style={{ textAlign: "center" }}>
                            {renderLoader(field)}
                          </td>
                          <td>
                            {(!field.is_premium || Access) && (
                              <div className="vcenter">
                                <div
                                  id={`div-${field.field_id}`}
                                  className="edit-div table-inputbox2 hidden"
                                >
                                  <input
                                    id={`input-${field.field_id}`}
                                    type="text"
                                    disabled={!field.is_override_enabled}
                                    value={
                                      formFields[field.keys] !== undefined &&
                                      formFields[field.keys].override === true
                                        ? formFields[field.keys].value
                                        : ""
                                    }
                                    className="login-input"
                                    defaultValue="0"
                                    name={field.keys}
                                    onChange={(e) => {
                                      getFieldValues(
                                        e,
                                        true,
                                        false,
                                        field.field_data_type,
                                        true,
                                      );
                                    }}
                                  />
                                </div>
                                <div className="field tooltip-p">
                                  <img
                                    id={`edit-${field.field_id}`}
                                    alt=""
                                    src="../assets/edit.png"
                                    width="23"
                                    height="23"
                                    onClick={() => {
                                      openEditBox(
                                        field.field_id,
                                        true,
                                        field?.keys,
                                      );
                                    }}
                                    className={
                                      field.is_override_enabled === false
                                        ? "hidden editimg"
                                        : "editimg"
                                    }
                                  />
                                </div>
                                <img
                                  id={`cross-${field.field_id}`}
                                  alt=""
                                  src="../assets/cross.png"
                                  width="24"
                                  height="24"
                                  onClick={() => {
                                    openEditBox(
                                      field.field_id,
                                      false,
                                      field?.keys,
                                    );
                                  }}
                                  className="hidden crossimg"
                                />
                              </div>
                            )}
                          </td>
                        </tr>
                      );
                    } else if (field.field_input_type === "textfield") {
                      return (
                        <div
                          key={field.field_id}
                          className={
                            "field-wrapper " +
                            (isXYZField(field.name)
                              ? " flex-item-xyz"
                              : "flex-item")
                          }
                        >
                          <div
                            className={
                              (primaryFields.includes(field.name)
                                ? "field-label "
                                : "field-label-secondary ") +
                              (!field.access ? "permium-row" : "")
                            }
                            // style={{ width: field.access ? "50%" : "100%" }}
                          >
                            <div className="field">
                              <p
                              // className={
                              //   field.name === "z" && "margin-bottom-xp"
                              // }
                              >
                                {field.name}
                                {isRequiredField(field.name) && (
                                  <RequiredMark />
                                )}
                              </p>
                              {!field.is_premium || Access ? (
                                renderTooltip(field)
                              ) : (
                                <a
                                  href="/premium-request"
                                  className="premium-row-text"
                                >
                                  Premium
                                </a>
                              )}
                            </div>
                          </div>

                          <div>
                            {(!field.is_premium || Access) && (
                              <>
                                <div
                                  data-tip={field.field_info}
                                  // className="vcenter"
                                  className="field-input"
                                >
                                  <div
                                    className="table-inputbox"
                                    style={{ position: "relative" }}
                                  >
                                    <input
                                      type="text"
                                      className="login-input"
                                      name={field.keys}
                                      placeholder="Enter Here"
                                      disabled={!field.is_override_enabled}
                                      style={{
                                        width: field?.field_unit
                                          ? FIELD_IDS_WITH_SPECIAL_WIDTH.includes(
                                              field?.field_id,
                                            )
                                            ? "86%"
                                            : "90%"
                                          : "100%",
                                      }}
                                      value={
                                        formFields[field.keys] === undefined
                                          ? ""
                                          : (field.keys ===
                                                "cost_of_power_per_kw" ||
                                                field.keys ===
                                                  "cost_of_floor_space_per_year" ||
                                                field.keys ===
                                                  "additional_material_losses" ||
                                                field.keys === "scrap_rate" ||
                                                field.keys ===
                                                  "support_factor" ||
                                                field.keys ===
                                                  "additional_material_losses") &&
                                              formFields[field.keys].value === 0
                                            ? ""
                                            : formFields[field.keys].value
                                      }
                                      onChange={(e) => {
                                        field.keys === "part_volume" ||
                                        field.keys === "part_support_volume" ||
                                        field.keys === "no_of_parts"
                                          ? getFieldValues(
                                              e,
                                              true,
                                              true,
                                              field.field_data_type,
                                              false,
                                              true,
                                            )
                                          : getFieldValues(
                                              e,
                                              true,
                                              false,
                                              field.field_data_type,
                                              false,
                                              false,
                                              true,
                                            );
                                      }}
                                    />

                                    {renderSubscript(field.field_unit)}
                                    {field.is_override_enabled && (
                                      <OverrideAbleTip />
                                    )}
                                  </div>
                                </div>
                                <span
                                  id={`error-${field.keys}`}
                                  className="error-messages"
                                >
                                  {field.name} is Required
                                </span>
                              </>
                            )}
                          </div>
                        </div>
                      );
                    } else if (field.field_input_type === "slider") {
                      const sliderValues = [1, 0.9, 0.8, 0.7, 0.6, 0.5];
                      const currentFieldValue =
                        formFields[field.keys] === undefined
                          ? 1
                          : Number(formFields[field.keys].value);
                      const currentIndexRaw =
                        sliderValues.indexOf(currentFieldValue);
                      const currentIndex =
                        currentIndexRaw === -1 ? 0 : currentIndexRaw;
                      return (
                        <div
                          key={field.field_id}
                          className={
                            "field-wrapper " +
                            (isXYZField(field.name)
                              ? " flex-item-xyz"
                              : "flex-item")
                          }
                        >
                          <div
                            className={
                              (primaryFields.includes(field.name)
                                ? "field-label "
                                : "field-label-secondary ") +
                              (!field.access ? "permium-row" : "")
                            }
                          >
                            <div className="field">
                              <p>
                                {field.name}
                                {isRequiredField(field.name) && (
                                  <RequiredMark />
                                )}
                              </p>
                              {!field.is_premium || Access ? (
                                renderTooltip(field)
                              ) : (
                                <a
                                  href="/premium-request"
                                  className="premium-row-text"
                                >
                                  Premium
                                </a>
                              )}
                            </div>
                          </div>

                          <div
                            data-tip={field.field_info}
                            className="field-input"
                          >
                            <div>
                              <input
                                type="range"
                                className="slider-range"
                                name={field.keys}
                                min={0}
                                max={sliderValues.length - 1}
                                step={1}
                                defaultValue={1}
                                disabled={!field.is_override_enabled}
                                value={currentIndex}
                                onChange={(e) => {
                                  const indexValue = Number(e.target.value);
                                  const mappedValue = sliderValues[indexValue];
                                  const syntheticEvent = {
                                    target: {
                                      name: field.keys,
                                      value: mappedValue,
                                    },
                                  };
                                  getFieldValues(
                                    syntheticEvent,
                                    true,
                                    false,
                                    field.field_data_type,
                                    false,
                                    false,
                                    true,
                                  );
                                }}
                              />
                              {/* {renderSubscript(field.field_unit)} */}
                            </div>
                            <div className="slider-ticks">
                              {sliderValues.map((val, idx) => {
                                const leftPercent =
                                  (idx / (sliderValues.length - 1)) * 100;
                                return (
                                  <span
                                    key={`${field.field_id}-tick-${idx}`}
                                    style={{ left: `${leftPercent}%` }}
                                    role="button"
                                    tabIndex={0}
                                    onClick={() => {
                                      const syntheticEvent = {
                                        target: {
                                          name: field.keys,
                                          value: val,
                                        },
                                      };
                                      getFieldValues(
                                        syntheticEvent,
                                        true,
                                        false,
                                        field.field_data_type,
                                        false,
                                        false,
                                        true,
                                      );
                                    }}
                                    onKeyDown={(e) => {
                                      if (e.key === "Enter" || e.key === " ") {
                                        const syntheticEvent = {
                                          target: {
                                            name: field.keys,
                                            value: val,
                                          },
                                        };
                                        getFieldValues(
                                          syntheticEvent,
                                          true,
                                          false,
                                          field.field_data_type,
                                          false,
                                          false,
                                          true,
                                        );
                                      }
                                    }}
                                  >
                                    {val}
                                  </span>
                                );
                              })}
                            </div>
                          </div>
                          {/* <span id={`error-${field.keys}`} className="error-messages">
                                  {field.name} is Required
                                </span> */}
                        </div>
                      );
                    } else if (field.field_input_type === "label_section") {
                      return (
                        <div className="hr w-100 mt-36 ">
                          {/* <div
                            className={
                              "heading-bolder" +
                              (!field.access ? "permium-row" : "")
                            }
                            style={{ width: field.access ? "50%" : "100%" }}
                          > */}
                          <div className="field mb-12 ">
                            <div className="flex-column align-items-start">
                            <p className="field-heading">{field.name}</p>
                            {field?.field_id === 194 && (
                              <>
                                <br />

                                <p>
                                  Please enter bounding box dimensions of part
                                </p>
                              </>
                            )}
                            </div>
                            {!field.is_premium || Access ? (
                              renderTooltip(field)
                            ) : (
                              <a
                                href={CONDITIONALROUTES.PREMIUM_REQUEST}
                                className="premium-row-text"
                              >
                                Premium
                              </a>
                            )}
                          </div>
                          {/* </div> */}
                        </div>
                      );
                    } else if (
                      field.field_input_type === "enable_multiple_rows"
                    ) {
                      // Determine if we can still add heterogeneous jobs based on shared limit (3)
                      let currentHetroJobsCount = 0;
                      if (technologyName === "Polymer Simulation") {
                        currentHetroJobsCount = tempHetrogeneousJobs.length / 2;
                      } else {
                        currentHetroJobsCount = tempHetrogeneousJobs.length / 3;
                      }

                      let scenariosCount = 0;
                      const calculatorValuesNames = sessionStorage.getItem(
                        "calculator_values_names",
                      );
                      if (calculatorValuesNames) {
                        try {
                          const parsedNames = JSON.parse(calculatorValuesNames);
                          if (Array.isArray(parsedNames)) {
                            scenariosCount = parsedNames.filter(
                              (name) => name !== constant.DEFAULT_SCENARIO,
                            ).length;
                          }
                        } catch (error) {
                          // ignore parsing issues
                        }
                      }

                      const canAddMoreHetroJobs =
                        currentHetroJobsCount < 3 &&
                        currentHetroJobsCount + scenariosCount < 3;

                      return (
                        <React.Fragment key={field.field_id}>
                          {renderRetroJobs()}
                          {canAddMoreHetroJobs && (
                            <div className="w-100">
                              <div
                                id="add-more"
                                onClick={() =>
                                  addMoreJobs(technologyName, index)
                                }
                              >
                                <img alt="" src="../assets/add.svg" />
                                <p> Add more for heterogeneous job</p>
                                {!field.is_premium || Access ? (
                                  renderTooltip(field)
                                ) : (
                                  <a
                                    href="/premium-request"
                                    className="premium-row-text"
                                  >
                                    Premium
                                  </a>
                                )}
                              </div>
                            </div>
                          )}
                        </React.Fragment>
                      );
                    }
                  })
                }
                {/* {
                                    !Access && renderPermiumShow()
                                } */}
              </div>
              {/* </table> */}
              <div className="mt-24">
                <span className="font-semi-bold">
                  <span className="required ml-1">*</span>
                  Mandatory fields
                   </span>
            
              </div>
            </div>
          </div>
        </div>
        {renderButtons()}
      </>
    );
  };

  const renderFields = () => {
    if (fieldsLoader) {
      return (
        <>
          <div className="row fill" id="map">
            <div className="col p-0 deadcenter ">
              <img
                className="mt-n5"
                src={Spinner}
                alt="loader"
                height="100px"
              />
            </div>
          </div>
        </>
      );
    } else {
      return <>{renderComponents()}</>;
    }
  };

  return (
    <React.Fragment>
      <ToastContainer />
      <Navbar />
      {/* <Banner /> */}

      {loading ? (
        <>
          <div className="row p-0 my-36">
            <div className="col p-0">
              <div className=" bar">
                <div className="row progress-holder">{renderSteps()}</div>
              </div>
            </div>
          </div>
          {renderFields()}
          <ReactTooltip />
        </>
      ) : (
        <div className="row pad-50 fill" id="map">
          <div className="col p-0 deadcenter ">
            <img className="mt-n5" src={Spinner} alt="loader" height="100px" />
          </div>
        </div>
      )}
      {isOpen && <BatchFillingPop isOpen={isOpen} setIsOpen={setIsOpen} />}
    </React.Fragment>
  );
};

export default CalculatorHeader;
